<h1 style="margin: 24px">Biosicherheitsplan Schwein
    <span *ngIf="!isReadOnly()" style="color: gray; font-size: 14px; font-weight: normal; margin-left: 16px"
        >Eingaben werden automatisch gespeichert</span
    >
</h1>
<div style="margin: 12px">
    <ng-container *kienePermission="[1255]">
        <div class="one-row" style="margin: 0 24px; width: 30vw; min-width: 320px">
            <kiene-autocomplete
                (elementSelected)="setTierarzt($event)"
                [disabled]="bsp.status_id === 232 || bsp.status_id === 250 || bsp.status_id === 251 || isReadOnly()"
                [displayFields]="['vorname', 'nachname']"
                [focus]="bsp?.tierarzt_id !== undefined"
                [genericApiUrl]="'tierarzt/read_autocomplete.php'"
                [kieneObject]="currentVet"
                [placeholder]="'Tierarzt'"
                style="width: 100%"
            ></kiene-autocomplete>
            <span class="spacer"></span>
        </div>
    </ng-container>
    <div class="one/row">
        <h2 class="margin-left">1. ANGABEN ZUR EPIDEMIOLOGISCHEN EINHEIT</h2>
    </div>
    <div style="width: 30vw; min-width: 320px">
        <table class="epidemiologische_einheit">
            <tr>
                <td colspan="1">
                    <mat-form-field style="width: 100%">
                        <mat-label>Datum</mat-label>
                        <input
                            [formControl]="fc_v1_1_datum"
                            [matDatepicker]="picker"
                            matInput
                            (dateChange)="saveBspTimeout()"
                        />
                        <mat-datepicker-toggle [for]="picker" matSuffix> </mat-datepicker-toggle>
                        <mat-datepicker #picker></mat-datepicker>
                    </mat-form-field>
                </td>
            </tr>
            <tr>
                <td colspan="4">
                    <h3>Tierhalter</h3>
                </td>
            </tr>
            <tr>
                <td colspan="1">
                    <div class="document-form">
                        <span class="label">VVVO-Nummer(n):</span>
                        <strong>{{ bsp?.vvvo }}</strong>
                    </div>
                </td>
            </tr>
            <tr>
                <td colspan="1">
                    <div class="document-form">
                        <span class="label">Betrieb:</span>
                        <strong>{{ bsp?.kunde }}</strong>
                        <button
                            mat-icon-button
                            matTooltip="Betrieb ändern"
                            (click)="betriebAendern()"
                            color="accent"
                            [disabled]="isLoadingOrSaving() || isReadOnly()"
                        >
                            <mat-icon>edit</mat-icon>
                        </button>
                    </div>
                </td>
            </tr>
            <tr>
                <td colspan="1">
                    <div class="document-form">
                        <span class="label">Adresse:</span>
                        <strong>{{ getAdresse() }}</strong>
                    </div>
                </td>
            </tr>
            <!--<tr>
                <td colspan="1">
                    <div class="document-form">
                        <span class="label">Telefon:</span>
                        <strong>{{ currentClient?.telefon_1 }}</strong>
                    </div>
                </td>
            </tr>
            <tr>
                <td colspan="1">
                    <div class="document-form">
                        <span class="label">Telefax:</span>
                        <strong>{{ currentClient?.fax }}</strong>
                    </div>
                </td>
            </tr>
            <tr>
                <td colspan="1">
                    <div class="document-form">
                        <span class="label">E-Mail:</span>
                        <strong>{{ currentClient?.email }}</strong>
                    </div>
                </td>
            </tr>-->
            <tr>
                <td colspan="1">
                    <mat-form-field style="width: 100%">
                        <mat-label>Wichtig für die Beihilfe der TSK:</mat-label>
                        <input matInput [formControl]="fc_v1_5_beihilfe_tsk" (change)="saveBspTimeout()" />
                    </mat-form-field>
                </td>
            </tr>
            <td>
                <div class="document-form">
                    <span class="label">TSK-Nummer: </span>
                    <strong>{{ bsp?.tsk_nummer }}</strong>
                    <button
                        *kienePermission="[11008]"
                        mat-icon-button
                        matTooltip="TSK Nummer hinterlegen"
                        (click)="openTSKDialog()"
                        color="accent"
                        [disabled]="isLoadingOrSaving() || isReadOnly()"
                    >
                        <mat-icon>edit</mat-icon>
                    </button>
                </div>
            </td>
            <tr>
                <td colspan="1">
                    <div class="one-row">
                        <mat-checkbox [formControl]="fc_v1_7_steuer_optierend" (change)="saveBSP()">
                            Besteuerung optierend
                        </mat-checkbox>
                        <mat-checkbox
                            [formControl]="fc_v1_8_steuer_pauschal"
                            style="margin-left: 36px"
                            (change)="saveBSP()"
                            >Besteuerung pauschal
                        </mat-checkbox>
                        <span class="spacer"></span>
                    </div>
                </td>
            </tr>
            <tr>
                <td class="sektion_headline" colspan="4">
                    <h3>Verantwortliche Person</h3>
                </td>
            </tr>
            <td colspan="1">
                <mat-form-field style="width: 100%">
                    <mat-label>verantwortliche Person</mat-label>
                    <input [formControl]="fc_v1_2_verantwortlich" matInput (change)="saveBspTimeout()" />
                </mat-form-field>
            </td>
            <tr>
                <td colspan="1">
                    <mat-form-field style="width: 100%">
                        <mat-label>PLZ, Ort, Straße, Hausnummer</mat-label>
                        <input [formControl]="fc_v1_3_verantwortlich_adresse" matInput (change)="saveBspTimeout()" />
                    </mat-form-field>
                </td>
            </tr>
            <tr>
                <td colspan="1">
                    <mat-form-field style="width: 100%">
                        <mat-label>Verantwortlicher Telefon</mat-label>
                        <input [formControl]="fc_v1_4_verantwortlich_telefon" matInput (change)="saveBspTimeout()" />
                    </mat-form-field>
                </td>
            </tr>
            <tr>
                <td colspan="1">
                    <mat-form-field style="width: 100%">
                        <mat-label>Verantwortlicher Email</mat-label>
                        <input
                            [formControl]="fc_v1_6_verantwortlich_email"
                            matInput
                            type="email"
                            (change)="saveBspTimeout()"
                        />
                    </mat-form-field>
                </td>
            </tr>
            <tr>
                <td class="sektion_headline" colspan="4">
                    <h3>Organisation</h3>
                </td>
            </tr>
            <tr>
                <td colspan="1">
                    <mat-form-field style="width: 100%">
                        <mat-label><strong>Landwirtschaftlicher Fachberater</strong> - Name(n):</mat-label>
                        <input [formControl]="fc_v1_9_berater_name" matInput (change)="onBeraterNameChanged()" />
                    </mat-form-field>
                </td>
            </tr>
            <tr>
                <td colspan="1">
                    <mat-form-field style="width: 100%">
                        <mat-label>Adresse (PLZ, Ort, Straße, Hausnummer):</mat-label>
                        <input [formControl]="fc_v1_10_berater_adresse" matInput (change)="saveBspTimeout()" />
                    </mat-form-field>
                </td>
            </tr>
            <tr>
                <td colspan="1">
                    <mat-form-field style="width: 100%">
                        <mat-label>Telefon:</mat-label>
                        <input [formControl]="fc_v1_11_berater_telefon" matInput (change)="saveBspTimeout()" />
                    </mat-form-field>
                </td>
            </tr>
            <tr>
                <td colspan="1">
                    <mat-form-field style="width: 100%">
                        <mat-label>E-Mail:</mat-label>
                        <input
                            [formControl]="fc_v1_12_berater_email"
                            matInput
                            type="email"
                            (change)="saveBspTimeout()"
                        />
                    </mat-form-field>
                </td>
            </tr>
            <tr>
                <td class="sektion_headline" colspan="4">
                    <h3>Betriebsstandort</h3>
                </td>
            </tr>
            <tr>
                <td colspan="1">
                    <mat-form-field style="width: 100%">
                        <mat-label>Adresse (PLZ, Ort, Straße, Hausnummer):</mat-label>
                        <input [formControl]="fc_v1_13_standort_adresse" matInput (change)="saveBspTimeout()" />
                    </mat-form-field>
                </td>
            </tr>
            <tr>
                <td colspan="1">
                    <mat-form-field style="width: 100%">
                        <mat-label>Ställe mit Bezeichnung:</mat-label>
                        <input [formControl]="fc_v1_15_stall_bezeichnungen" matInput (change)="saveBspTimeout()" />
                    </mat-form-field>
                </td>
            </tr>
            <tr>
                <td colspan="1">
                    <mat-form-field style="width: 100%">
                        <mat-label>Anzahl Sauenplätze:</mat-label>
                        <input
                            [formControl]="fc_v1_16_anzahl_sauenplaetze"
                            type="number"
                            matInput
                            (change)="saveBspTimeout()"
                        />
                    </mat-form-field>
                </td>
            </tr>
            <tr>
                <td colspan="1">
                    <mat-form-field style="width: 100%">
                        <mat-label>Anzahl Aufzuchtplätze:</mat-label>
                        <input
                            [formControl]="fc_v1_17_anzahl_aufzuchtplaetze"
                            type="number"
                            matInput
                            (change)="saveBspTimeout()"
                        />
                    </mat-form-field>
                </td>
            </tr>
            <tr>
                <td colspan="1">
                    <mat-form-field style="width: 100%">
                        <mat-label>Anzahl Mastplätze:</mat-label>
                        <input
                            [formControl]="fc_v1_18_anzahl_mastplaetze"
                            type="number"
                            matInput
                            (change)="saveBspTimeout()"
                        />
                    </mat-form-field>
                </td>
            </tr>
            <tr>
                <td colspan="1">
                    <div class="one-row">
                        <mat-form-field style="width: 100%; margin-right: 12px">
                            <mat-label>Art und Weise der Aufstallung/Haltung :</mat-label>
                            <input [formControl]="fc_v1_23_aufstallung" matInput (change)="saveBspTimeout()" />
                        </mat-form-field>
                        <mat-checkbox [formControl]="fc_v1_19_mit_auslauf" (change)="saveBSP()"
                            >mit Auslauf
                        </mat-checkbox>
                        <mat-checkbox [formControl]="fc_v1_20_freiland" style="margin-left: 36px" (change)="saveBSP()"
                            >Freilandhaltung
                        </mat-checkbox>
                        <mat-checkbox [formControl]="fc_v1_21_stroh" style="margin-left: 36px" (change)="saveBSP()"
                            >Stroh
                        </mat-checkbox>
                        <span class="spacer"></span>
                    </div>
                </td>
            </tr>
            <tr> </tr>
            <tr>
                <td colspan="1">
                    <mat-form-field style="width: 100%">
                        <mat-label>anzuwendende Anlage nach SchHaltHygV:</mat-label>
                        <input [formControl]="fc_v1_22_anlage" matInput (change)="saveBspTimeout()" />
                    </mat-form-field>
                </td>
            </tr>
        </table>
    </div>

    <!--    Seite 2-->
    <div class="one/row">
        <h2 class="margin-left">2. BETRIEBSINDIVIDUELLE RISIKOFAKTOREN, DIE SICH AUS DER LAGE DES BETRIEBES ERGEBEN</h2>
    </div>
    <table class="biosicherheitsplan">
        <tr class="sektion_header">
            <th class="head1">Handlungsbedarf</th>
            <th class="head2">Lfd.Nr.</th>
            <th class="head3">zu berücksichtigen</th>
            <th class="head4">Antworten, Anmerkungen</th>
            <th class="head5">Ergänzende Unterlagen</th>
        </tr>
        <tr class="table_row">
            <td class="cell1"></td>
            <td class="cell2">2.1</td>
            <td class="cell3">Art, Größe und Lage/Adresse des Betriebes?</td>
            <td class="cell4">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v2_1_antwort"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
            <td class="cell5">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v2_1_unterlage"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
        </tr>
        <tr class="table_row">
            <td class="cell1"></td>
            <td class="cell2">2.2</td>
            <td class="cell3">In welchem Gelände liegt der Betrieb (z. B. Ortsrandlage, Feldflur, Waldlage etc.)?</td>
            <td class="cell4">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v2_2_antwort"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
            <td class="cell5">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v2_2_unterlage"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
        </tr>
        <tr class="table_row">
            <td class="cell1"></td>
            <td class="cell2">2.3</td>
            <td class="cell3"
                >Welche weiteren epidemiologischen Einheiten werden bewirtschaftet und welche baulichen Vorkehrungen zur
                Trennung voneinander gibt es? …
            </td>
            <td class="cell4">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v2_3_antwort"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
            <td class="cell5">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v2_3_unterlage"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
        </tr>
        <tr class="table_row">
            <td class="cell1"></td>
            <td class="cell2">2.4</td>
            <td class="cell3"
                >Welche Verbindungen bestehen zwischen den epidemiologischen Einheiten, z. B. Verbringungen von Tieren
                oder Futtermitteln, gleiches Betreuungspersonal, Betriebsfahrzeug, gemeinsam genutzte Gerätschaften etc…
            </td>
            <td class="cell4">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v2_4_antwort"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
            <td class="cell5">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v2_4_unterlage"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
        </tr>
        <tr class="table_row">
            <td class="cell1"></td>
            <td class="cell2">2.5</td>
            <td class="cell3">Gibt es Schweinehaltungen im Radius von 500 m um den Betrieb?</td>
            <td class="cell4">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v2_5_antwort"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
            <td class="cell5">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v2_5_unterlage"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
        </tr>
        <tr class="table_row">
            <td class="cell1"></td>
            <td class="cell2">2.6</td>
            <td class="cell3"
                >Welche weiteren relevanten möglichen Infektionsquellen in der Umgebung (3 km) wie z. B. Schlachthof,
                Schweinetransportunternehmen, Wildschweingatter, LKW-Rastplätze, Autobahnrastplätze etc. gibt es?
            </td>
            <td class="cell4">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v2_6_antwort"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
            <td class="cell5">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v2_6_unterlage"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
        </tr>
        <tr class="table_row">
            <td class="cell1"></td>
            <td class="cell2">2.7</td>
            <td class="cell3"
                >Welche zuführenden Straßen und Wege zum Betrieb werden auch von anderen landwirtschaftlichen Betrieben
                genutzt?
            </td>
            <td class="cell4">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v2_7_antwort"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
            <td class="cell5">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v2_7_unterlage"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
        </tr>
        <tr class="table_row">
            <td class="cell1"></td>
            <td class="cell2">2.8</td>
            <td class="cell3">Erreichen Wildschweine die Betriebsgrenzen?</td>
            <td class="cell4">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v2_8_antwort"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
            <td class="cell5">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v2_8_unterlage"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
        </tr>
        <tr class="table_row">
            <td class="cell1"></td>
            <td class="cell2">2.9</td>

            <td class="cell3"
                >Gibt es Saison-/Fremdarbeitskräfte? Wenn ja, haben diese außerhalb des Betriebes Kontakt zu Schweinen
                oder regelmäßig Kontakt zu Gebieten mit ASP- Problematik? Werden für diese Personen Informationen in
                ihrer Muttersprache zur Verfügung gestellt?
            </td>
            <td class="cell4">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v2_9_antwort"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
            <td class="cell5">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v2_9_unterlage"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
        </tr>
        <tr class="table_row">
            <td class="cell1">
                <mat-checkbox [formControl]="fc_v2_10_handlungsbedarf" (change)="saveBSP()"></mat-checkbox>
            </td>
            <td class="cell2">2.10</td>
            <td class="cell3">Gibt es Regelungen für die Haltung von Schweinen durch das Personal?</td>
            <td class="cell4">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v2_10_antwort"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
            <td class="cell5">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v2_10_unterlage"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
        </tr>
        <tr class="table_row">
            <td class="cell1">
                <mat-checkbox [formControl]="fc_v2_11_handlungsbedarf" (change)="saveBSP()"></mat-checkbox>
            </td>
            <td class="cell2">2.11</td>

            <td class="cell3"
                >Sind Mitarbeiter – auch anderer Betriebszweige – jagdlich aktiv? Wenn ja, üblicherweise in welchen
                Revieren/ Regionen? Wie wird sichergestellt, dass es keine Kontakte zwischen jagdlich genutzter
                Ausrüstung und Schweinehaltung gibt? Gibt es Regelungen für die Vermeidung jeglichen Kontakts zu
                gehaltenen Schweinen nach jagdlichen Aktivitäten (notwendig im Seuchenfall gemäß DVO 2023/594 Anhang III
                2. d): min. 48 Stunden ab Beendigung jeglicher Jagdtätigkeiten)?
            </td>
            <td class="cell4">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v2_11_antwort"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
            <td class="cell5">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v2_11_unterlage"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
        </tr>
        <tr class="table_row">
            <td class="cell1">
                <mat-checkbox [formControl]="fc_v2_12_handlungsbedarf" (change)="saveBSP()"></mat-checkbox>
            </td>
            <td class="cell2">2.12</td>
            <td class="cell3">Welche Vorgaben für die Mitnahme von Verpflegung der Mitarbeiter sind vorhanden?</td>
            <td class="cell4">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v2_12_antwort"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
            <td class="cell5">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v2_12_unterlage"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
        </tr>
    </table>

    <!--    Seite3-->

    <div class="one/row">
        <h2 class="margin-left">3. LAGESKIZZE DES BETRIEBES (ALS ANLAGE)</h2>
    </div>

    <!--    image legende anzeigen-->
    <div class="one/row">
        <h3 class="margin-left">Legende</h3>
    </div>
    <div class="one-row">
        <img
            src="assets/bio_sicherheitsplan_legende.png"
            alt="Legende"
            style="width: 100%; max-width: 800px; margin: 0 auto; display: block"
        />
        <span class="spacer"></span>
    </div>

    <div class="pdf-upload-container">
        <div>
            <input
                #fileInput3
                (change)="onFileChange($event, 'sektion3')"
                [disabled]="isLoadingOrSaving() || isReadOnly()"
                accept=".pdf"
                hidden
                type="file"
            />
            <button
                (click)="handleFileButtonClick(fileInput3)"
                [disabled]="isLoadingOrSaving() || isReadOnly()"
                color="primary"
                mat-stroked-button
            >
                Lageplan Skizze PDF hinzufügen
            </button>
        </div>

        <div class="chip-list-wrapper">
            <mat-chip-list aria-label="Pdf auswahl">
                <mat-chip
                    *ngFor="let biofile of getSektionFiles('sektion3')"
                    (click)="showFilePdf(biofile)"
                    [removable]="!isLoadingOrSaving() && !isReadOnly()"
                    (removed)="removeFile(biofile, 'sektion3')"
                    selectable="false"
                    matTooltip="{{ biofile?.dateiname || biofile?.file?.name }}"
                >
                    <mat-icon matChipAvatar>picture_as_pdf</mat-icon>
                    {{ biofile?.dateiname || biofile?.file?.name }}
                    <button
                        matChipRemove
                        *ngIf="!isLoadingOrSaving() && !isReadOnly()"
                        (click)="$event.stopPropagation()"
                    >
                        <mat-icon>cancel</mat-icon>
                    </button>
                </mat-chip>
            </mat-chip-list>
        </div>
    </div>

    <table class="biosicherheitsplan">
        <span class="spacer"></span>

        <tr>
            <td class="sektion_headline" colspan="5">Diese sollte Folgendes enthalten:</td>
        </tr>
        <tr class="sektion_header">
            <th class="head1">Handlungsbedarf</th>
            <th class="head2">Lfd.Nr.</th>
            <th class="head3">zu berücksichtigen</th>
            <th class="head4">Antworten, Anmerkungen</th>
            <th class="head5">Ergänzende Unterlagen</th>
        </tr>
        <tr class="table_row">
            <td class="cell1"></td>
            <td class="cell2">3.13</td>
            <td class="cell3"
                >Einfriedung / Wo verläuft der Zaun, wo Mauern? Welche Art von Zaun befindet sich an welchen Stellen?
                Wie groß sind die Maschen? Ist ein Unterwühlschutz vorhanden und wie ist dieser umgesetzt?
            </td>
            <td class="cell4">
                <div style="width: 20%; height: 100%"></div>
            </td>
            <td class="cell5">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v3_13_unterlage"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
        </tr>
        <tr class="table_row">
            <td class="cell1"></td>
            <td class="cell2">3.14</td>
            <td class="cell3"
                >Wo sind Tore und Durchgänge? Welche Art Tore? Durch welche Tore kommen welche Fahrzeuge?
            </td>
            <td class="cell4">
                <div style="width: 20%; height: 100%"></div>
            </td>
            <td class="cell5">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v3_14_unterlage"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
        </tr>
        <tr class="table_row">
            <td class="cell1"></td>
            <td class="cell2">3.15</td>
            <td class="cell3">Wo sind Türen?</td>
            <td class="cell4">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v3_15_antwort"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
            <td class="cell5">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v3_15_unterlage"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
        </tr>
        <tr class="table_row">
            <td class="cell1"></td>
            <td class="cell2">3.16</td>
            <td class="cell3"
                >Wo sind Schilder „Schweinebestand – für Unbefugte Betreten verboten" bzw. bei Freiland- und /oder
                Auslaufhaltungen „Schweinebestand – unbefugtes Füttern und Betreten verboten" angebracht?
            </td>
            <td class="cell4">
                <div style="width: 20%; height: 100%"></div>
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v3_16_antwort"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
            <td class="cell5">
                <div>
                    <p>Vorschlag:</p>
                    <mat-checkbox [formControl]="fc_v3_16_unterlage_ein_und_ausgaenge" (change)="saveBSP()"
                        >Ein- und Ausgänge
                    </mat-checkbox>
                    <br />
                    <mat-checkbox [formControl]="fc_v3_16_unterlage_leicht_erreichbare_stellen" (change)="saveBSP()"
                        >für Besucher leicht erreichbaren Stellen
                    </mat-checkbox>
                </div>
            </td>
        </tr>
        <tr class="table_row">
            <td class="cell1"></td>
            <td class="cell2">3.17</td>
            <td class="cell3">Wo ist der Parkplatz für Mitarbeiter / Besucher?</td>
            <td class="cell4">
                <div style="width: 20%; height: 100%"></div>
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v3_17_antwort"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
            <td class="cell5">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v3_17_unterlage"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
        </tr>
        <tr class="table_row">
            <td class="cell1"></td>
            <td class="cell2">3.18</td>
            <td class="cell3">Wo ist die Hygieneschleuse?</td>
            <td class="cell4">
                <div style="width: 20%; height: 100%"></div>
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v3_18_antwort"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
            <td class="cell5">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v3_18_unterlage"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
        </tr>
        <tr class="table_row">
            <td class="cell1"></td>
            <td class="cell2">3.19</td>
            <td class="cell3"
                >Wo gibt es ausgewiesene Einrichtungen (Speiseraum, Umkleide, Duschen, WC) für das Personal im reinen
                bzw. unreinen Bereich? (ggf. nötig für Sperrzonen I, II, III gemäß DVO (EU) 2023/594)
            </td>
            <td class="cell4">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v3_19_antwort"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
            <td class="cell5">
                <div>
                    <p>Vorschlag:</p>
                    <mat-checkbox [formControl]="fc_v3_19_unterlage_im_weissbereich" (change)="saveBSP()"
                        >im reinen/Weißbereich
                    </mat-checkbox>
                    <br />
                    <mat-checkbox [formControl]="fc_v3_19_unterlage_im_schwarzbereich" (change)="saveBSP()"
                        >im unreinen / Schwarzbereich
                    </mat-checkbox>
                    <br />
                    <div class="one-row">
                        <mat-checkbox [formControl]="fc_v3_19_unterlage_sonstiges" (change)="saveBSP()"> </mat-checkbox>
                        <span class="spacer"></span>
                        <mat-form-field style="width: 97%">
                            <textarea
                                [formControl]="fc_v3_19_unterlage_sonstiges_text"
                                cdkAutosizeMinRows="{{ rowspan }}"
                                cdkTextareaAutosize
                                class="textarea"
                                matInput
                                (change)="saveBspTimeout()"
                            ></textarea>
                        </mat-form-field>
                    </div>
                </div>
            </td>
        </tr>
        <tr class="table_row">
            <td class="cell1"></td>
            <td class="cell2">3.20</td>
            <td class="cell3"
                >Vor welchen Eingängen stehen Desinfektionswannen/-matten für Schuhwerk? Wo findet regelmäßig
                Schuhwechsel statt?
            </td>
            <td class="cell4">
                <div style="width: 20%; height: 100%"></div>
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v3_20_unterlage"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
            <td class="cell5">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v3_20_antwort"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
        </tr>
        <tr class="table_row">
            <td class="cell1"></td>
            <td class="cell2">3.21</td>
            <td class="cell3">Wo sind die Futtersilos? Wo die Einblasstutzen?</td>
            <td class="cell4">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v3_21_antwort"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
            <td class="cell5">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v3_21_unterlage"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
        </tr>
        <tr class="table_row">
            <td class="cell1"></td>
            <td class="cell2">3.22</td>
            <td class="cell3">Wo werden weitere Futtermittel gelagert?</td>
            <td class="cell4">
                <div style="width: 20%; height: 100%"></div>
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v3_22_antwort"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
            <td class="cell5">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v3_22_unterlage"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
        </tr>
        <tr class="table_row">
            <td class="cell1"></td>
            <td class="cell2">3.23</td>
            <td class="cell3">Wo wird Einstreumaterial/ Beschäftigungsmaterial gelagert?</td>
            <td class="cell4">
                <div style="width: 20%; height: 100%"></div>
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v3_23_antwort"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
            <td class="cell5">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v3_23_unterlage"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
        </tr>
        <tr class="table_row">
            <td class="cell1"></td>
            <td class="cell2">3.24</td>
            <td class="cell3">Wo ist die Kadaverlagerung?</td>
            <td class="cell4">
                <div style="width: 20%; height: 100%"></div>
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v3_24_antwort"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
            <td class="cell5">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v3_24_unterlage"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
        </tr>
        <tr class="table_row">
            <td class="cell1"></td>
            <td class="cell2">3.25</td>
            <td class="cell3">Wo sind Köderstellen für die Schadnagerbekämpfung?</td>
            <td class="cell5">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v3_25_antwort"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
            <td class="cell4"> » siehe Plan</td>
        </tr>
        <tr class="table_row">
            <td class="cell1"></td>
            <td class="cell2">3.26</td>
            <td class="cell3">Wo ist das Güllelager? Wo wird Mist gelagert?</td>
            <td class="cell4">
                <div style="width: 20%; height: 100%"></div>
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v3_26_antwort"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
            <td class="cell5">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v3_26_unterlage"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
        </tr>
        <tr class="table_row">
            <td class="cell1"></td>
            <td class="cell2">3.27</td>
            <td class="cell3"
                >Wo befindet sich die Möglichkeit, Fahrzeugreifen zu desinfizieren? Wo werden die Materialien hierfür
                gelagert?
            </td>
            <td class="cell4">
                <div style="width: 20%; height: 100%"></div>
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v3_27_antwort"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
            <td class="cell5">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v3_27_unterlage"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
        </tr>
        <tr class="table_row">
            <td class="cell1"></td>
            <td class="cell2">3.28</td>
            <td class="cell3"
                >In Schutzzonen (DelVO (EU)VO 2020/687) gilt für alle Betriebe: An den Zu- und Abfahrtswegen müssen
                geeignete Desinfektionsmittel angewendet werden. Für die Umsetzung dieser Vorgaben ist Folgendes
                vorgesehen: …
            </td>
            <td class="cell4">
                <div style="width: 20%; height: 100%"></div>
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v3_28_antwort"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
            <td class="cell5">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v3_28_unterlage"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
        </tr>
    </table>

    <!--    Seite 4 -->
    <ng-container *ngFor="let plan of reinigungsplaene; let i = index; trackBy: trackByIndex">
        <h2 class="margin-left">
            4<span *ngIf="reinigungsplaene.length > 1">{{ getBuchstabe(i) }}</span
            >. REINIGUNG UND DESINFEKTION
        </h2>

        <table class="biosicherheitsplan">
            <tr>
                <td class="sektion_headline" colspan="5">
                    Ablaufplan <span *ngIf="reinigungsplaene?.length > 1"> {{ getBuchstabe(i) }},</span> der
                    Informationen zu folgenden Punkten enthalten sollte , ggf. getrennt für verschiedene
                    Ställe/Produktionsbereiche
                </td>
            </tr>
            <tr>
                <td colspan="5">
                    <mat-form-field style="width: 100%">
                        <mat-label>Stall</mat-label>
                        <input
                            [formControl]="plan?.fc_stall"
                            matInput
                            placeholder="Für welchen Stall ist der Plan?"
                            type="text"
                            (change)="saveBspTimeout()"
                        />
                    </mat-form-field>
                </td>
            </tr>
            <tr class="sektion_header">
                <th class="col1">Handlungsbedarf</th>
                <th class="col2">Lfd.Nr.</th>
                <th class="col3">zu berücksichtigen</th>
                <th class="col4">Antworten, Anmerkungen</th>
                <th class="col5">Ergänzende Unterlagen</th>
            </tr>

            <tr *ngFor="let entry of plan.formControls; let pi = index; trackBy: trackByIndex" class="table_row">
                <td class="cell1">
                    <mat-checkbox [formControl]="entry.handlungsbedarf" (change)="saveBSP()"></mat-checkbox>
                </td>
                <td class="cell2">
                    4<span *ngIf="reinigungsplaene.length > 1">{{ getBuchstabe(i) | lowercase }}</span>.{{ pi + 29 }}.
                </td>

                <td class="cell3">
                    <!-- Stelle deine Fragen hier je nach Index -->
                    <div class="one-row">
                        <span>{{ entry.getFragenText(pi) }}</span>
                        <ng-container *ngIf="entry?.massnahmen && entry.getFragenText(pi) === 'Weitere Maßnahmen: …'">
                            <mat-form-field style="width: 100%">
                                <textarea
                                    [formControl]="entry.massnahmen"
                                    matInput
                                    rows="3"
                                    (change)="saveBspTimeout()"
                                ></textarea>
                            </mat-form-field>
                        </ng-container>
                    </div>
                </td>
                <td class="cell4">
                    <mat-form-field style="width: 100%">
                        <textarea
                            [formControl]="entry.antwort"
                            matInput
                            rows="3"
                            (change)="saveBspTimeout()"
                        ></textarea>
                    </mat-form-field>
                </td>
                <td class="cell5">
                    <mat-form-field style="width: 100%">
                        <textarea
                            [formControl]="entry.unterlage"
                            matInput
                            rows="3"
                            (change)="saveBspTimeout()"
                        ></textarea>
                    </mat-form-field>
                </td>
            </tr>
            <tr>
                <td colspan="5">
                    <button
                        mat-stroked-button
                        (click)="removeReinigung(plan)"
                        [disabled]="isLoadingOrSaving() || reinigungsplaene.length === 1"
                    >
                        <mat-icon>delete</mat-icon>
                        Reinigungsplan entfernen
                    </button>
                </td>
            </tr>
        </table>

        <ng-container *ngIf="i + 1 === reinigungsplaene?.length">
            <div class="one-row">
                <button
                    [disabled]="isLoadingOrSaving() || isReadOnly()"
                    (click)="addReinigung()"
                    color="accent"
                    mat-stroked-button
                    matTooltip="weiteren Ablaufplan hinzufügen"
                    class="margin-left"
                    style="margin-bottom: 24px"
                >
                    <mat-icon>add</mat-icon>
                    Weiteren Reinigungsplan hinzufügen
                </button>
            </div>
        </ng-container>
    </ng-container>

    <!--    Seite 5-->
    <div class="one/row">
        <h2 class="margin-left">5. WIE GELANGEN TIERE IN MEINEN BETRIEB ODER NACH AUSSERHALB?</h2>
    </div>
    <table class="biosicherheitsplan">
        <tr>
            <td class="sektion_headline" colspan="5">
                Beim Verbringen oder Einstellen von Schweinen werden von mir und den beteiligten Viehhändlern /
                Viehtransporteuren folgende Maßnahmen ergriffen:
            </td>
        </tr>
        <tr class="sektion_header">
            <th class="head1">Handlungsbedarf</th>
            <th class="head2">Lfd.Nr.</th>
            <th class="head3">zu berücksichtigen</th>
            <th class="head4">Antworten, Anmerkungen</th>
            <th class="head5">Ergänzende Unterlagen</th>
        </tr>
        <tr class="table_row">
            <td class="cell1">
                <mat-checkbox [formControl]="fc_v5_36_handlungsbedarf" (change)="saveBSP()"></mat-checkbox>
            </td>
            <td class="cell2">5.36</td>
            <td class="cell3"
                >Wie wird kontrolliert, dass die Tiere nur mit zuvor gereinigten und desinfizierten Fahrzeugen
                transportiert werden? Gibt es Tiertransporte, die bereits mit Tieren fremder Betriebe beladen sind?
            </td>
            <td class="cell4">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v5_36_antwort"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
            <td class="cell5">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v5_36_unterlage"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
        </tr>
        <tr class="table_row">
            <td class="cell1">
                <mat-checkbox [formControl]="fc_v5_37_handlungsbedarf" (change)="saveBSP()"></mat-checkbox>
            </td>
            <td class="cell2">5.37</td>
            <td class="cell3"
                >Die am Viehverkehr sowie die bei der Ver- oder Entladung beteiligten betriebsfremden Personen betreten
                den Stallbereich nur über die Hygieneschleuse und in Schutzkleidung. Dies stelle ich wie folgt sicher: …
            </td>
            <td class="cell4">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v5_37_antwort"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
            <td class="cell5">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v5_37_unterlage"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
        </tr>
        <tr class="table_row">
            <td class="cell1">
                <mat-checkbox [formControl]="fc_v5_38_handlungsbedarf" (change)="saveBSP()"></mat-checkbox>
            </td>
            <td class="cell2">5.38</td>
            <td class="cell3"
                >Auf das Transportfahrzeug verladene Tiere laufen nicht in den Stall zurück. Dies wird dadurch
                gewährleistet, dass: …
            </td>
            <td class="cell4">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v5_38_antwort"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
            <td class="cell5">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v5_38_unterlage"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
        </tr>
        <tr class="table_row">
            <td class="cell1">
                <mat-checkbox [formControl]="fc_v5_39_handlungsbedarf" (change)="saveBSP()"></mat-checkbox>
            </td>
            <td class="cell2">5.39</td>
            <td class="cell3"
                >Wie wird sichergestellt, dass Zucht- oder Nutzschweine nicht gemeinsam mit Schweinen aus einem anderen
                Betrieb befördert werden?
            </td>
            <td class="cell4">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v5_39_antwort"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
            <td class="cell5">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v5_39_unterlage"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
        </tr>
        <tr class="table_row">
            <td class="cell1">
                <mat-checkbox [formControl]="fc_v5_40_handlungsbedarf" (change)="saveBSP()"></mat-checkbox>
            </td>
            <td class="cell2">5.40</td>
            <td class="cell3"
                >Wie wird sichergestellt, dass nach jeder Einstallung oder Ausstallung von Schweinen die dazu
                eingesetzten Gerätschaften und der Verladeplatz gereinigt und desinfiziert werden (z. B.: Beschreibung
                in R+D-Plan, Mitarbeiterschulung, Überprüfung Ergebnis)? Wie ist dabei das Vorgehen?
            </td>
            <td class="cell4">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v5_40_antwort"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
            <td class="cell5">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v5_40_unterlage"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
        </tr>
        <tr class="table_row">
            <td class="cell1">
                <mat-checkbox [formControl]="fc_v5_41_handlungsbedarf" (change)="saveBSP()"></mat-checkbox>
            </td>
            <td class="cell2">5.41</td>
            <td class="cell3"
                >Wie wird sichergestellt, dass zwischen der Ausstallung und der Wiederbelegung der frei gewordene Stall
                einschließlich der vorhandenen Einrichtungen und Gegenstände gereinigt und desinfiziert wird (z. B.:
                Beschreibung in R+D-Plan, Mitarbeiterschulung, Überprüfung Ergebnis)? Wie ist dabei das Vorgehen?
            </td>
            <td class="cell4">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v5_41_antwort"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
            <td class="cell5">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v5_41_unterlage"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
        </tr>
        <tr class="table_row">
            <td class="cell1">
                <mat-checkbox [formControl]="fc_v5_42_handlungsbedarf" (change)="saveBSP()"></mat-checkbox>
            </td>
            <td class="cell2">5.42</td>
            <td class="cell3">Ggf. Anlage „Ablaufplan der Verladung und Entladung" </td>
            <td class="cell4">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v5_42_antwort"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
            <td class="cell5">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v5_42_unterlage"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
        </tr>
    </table>
    <div class="one/row">
        <h3 class="margin-left"> System des Zu- und Verkaufs:</h3>
    </div>
    <table class="biosicherheitsplan">
        <tr class="sektion_header">
            <th class="head1">Handlungsbedarf</th>
            <th class="head2">Lfd.Nr.</th>
            <th class="head3">zu berücksichtigen</th>
            <th class="head4">Antworten, Anmerkungen</th>
            <th class="head5">Ergänzende Unterlagen</th>
        </tr>
        <tr class="table_row">
            <td class="cell1"></td>
            <td class="cell2">5.43</td>
            <td class="cell3">
                <div>
                    <strong>Aufzucht- oder Mastbetriebe:</strong><br />
                    <mat-checkbox [formControl]="fc_v5_43_vollstaendig" (change)="saveBSP()"
                        >rein/raus vollständig (Betrieb / Stall)
                    </mat-checkbox>
                    <br />
                    <mat-checkbox [formControl]="fc_v5_43_restemast" (change)="saveBSP()"
                        >rein/raus (Betrieb / Stall) (z. B. Restemast in einem Abteil)
                    </mat-checkbox>
                    <br />
                    <mat-checkbox [formControl]="fc_v5_43_abteilweise" (change)="saveBSP()"
                        >rein/raus abteilweise
                    </mat-checkbox>
                </div>
            </td>
            <td class="cell4">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v5_43_antwort"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
            <td class="cell5">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v5_43_unterlage"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
        </tr>
        <tr class="table_row">
            <td class="cell1"></td>
            <td class="cell2">5.44</td>
            <td class="cell3">
                <div>
                    <strong>Zucht / gemischter Betrieb:</strong><br />
                    <mat-checkbox [formControl]="fc_v5_44_kein_zukauf" (change)="saveBSP()"
                        >keinerlei Zukauf
                    </mat-checkbox>
                    <br />
                    <mat-checkbox [formControl]="fc_v5_44_eber" (change)="saveBSP()">Zukauf von Ebern </mat-checkbox>
                    <br />
                    <mat-checkbox [formControl]="fc_v5_44_jungsauen" (change)="saveBSP()"
                        >Zukauf von Jungsauen
                    </mat-checkbox>
                    <br />
                    <mat-checkbox [formControl]="fc_v5_44_sonstige" (change)="saveBSP()"
                        >sonstiger Zugang von Tieren:…
                    </mat-checkbox>
                </div>
            </td>
            <td class="cell4">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v5_44_antwort"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
            <td class="cell5">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v5_44_unterlage"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
        </tr>
        <tr class="table_row">
            <td class="cell1"></td>
            <td class="cell2">5.45</td>
            <td class="cell3"> Zukauf in welchem Rhythmus?</td>
            <td class="cell4">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v5_45_antwort"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
            <td class="cell5">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v5_45_unterlage"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
        </tr>
        <tr class="table_row">
            <td class="cell1"></td>
            <td class="cell2">5.46</td>
            <td class="cell3">
                Zukauf aus gleichbleibenden / wechselnden Herkunftsbestand/Erzeugergemeinschaft? Wenn gleichbleibend:
                Seit wann?
            </td>
            <td class="cell4">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v5_46_antwort"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
            <td class="cell5">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v5_46_unterlage"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
        </tr>
        <tr class="table_row">
            <td class="cell1"></td>
            <td class="cell2">5.47</td>
            <td class="cell3"> Zukauf in einer festen Lieferkette? Vertrag vorhanden?</td>
            <td class="cell4">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v5_47_antwort"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
            <td class="cell5">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v5_47_unterlage"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
        </tr>
    </table>

    <!--    Seite 6-->
    <div class="one/row">
        <h2 class="margin-left">6. WIE GELANGEN WAREN UND ERZEUGNISSE WIE Z. B. FUTTER IN MEINEN BETRIEB?</h2>
    </div>
    <table class="biosicherheitsplan">
        <tr>
            <td class="sektion_headline" colspan="5">
                Folgende Maßnahmen beim Einbringen von Waren und Erzeugnissen in meinen Betrieb werden ergriffen:
            </td>
        </tr>
        <tr class="sektion_header">
            <th class="head1">Handlungsbedarf</th>
            <th class="head2">Lfd.Nr.</th>
            <th class="head3">zu berücksichtigen</th>
            <th class="head4">Antworten, Anmerkungen</th>
            <th class="head5">Ergänzende Unterlagen</th>
        </tr>
        <tr class="table_row">
            <td class="cell1">
                <mat-checkbox [formControl]="fc_v6_48_handlungsbedarf" (change)="saveBSP()"></mat-checkbox>
            </td>
            <td class="cell2">6.48</td>
            <td class="cell3"> Die Lagerung von Futter erfolgt in folgenden Gebäuden, Räumen oder Behältern: …</td>
            <td class="cell4">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v6_48_antwort"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
            <td class="cell5">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v6_48_unterlage"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
        </tr>
        <tr class="table_row">
            <td class="cell1">
                <mat-checkbox [formControl]="fc_v6_49_handlungsbedarf" (change)="saveBSP()"></mat-checkbox>
            </td>
            <td class="cell2">6.49</td>
            <td class="cell3"
                >Sofern möglich, werden Lieferfahrzeuge und Waren am Rande des Betriebsgeländes bzw. vor dem
                Betriebsgelände stehen gelassen bzw. entladen. Dies wird folgendermaßen umgesetzt:…
            </td>
            <td class="cell4">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v6_49_antwort"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
            <td class="cell5">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v6_49_unterlage"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
        </tr>
        <tr class="table_row">
            <td class="cell1">
                <mat-checkbox [formControl]="fc_v6_50_handlungsbedarf" (change)="saveBSP()"></mat-checkbox>
            </td>
            <td class="cell2">6.50</td>
            <td class="cell3"
                >Wie gelangt das Futter unter Beachtung des SchwarzWeiß-Prinzips in das Silo? z. B.: • Wird ein
                betriebseigener Siloausblasschlauch vorgehalten und eingesetzt? Sind feste Verrohrungen bis außerhalb
                des eingefriedeten Bereiches vorhanden? … • Der Einblasstutzen befindet sich an folgendem Ort:
            </td>
            <td class="cell4">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v6_50_antwort"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
            <td class="cell5">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v6_50_unterlage"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
        </tr>
        <tr class="table_row">
            <td class="cell1">
                <mat-checkbox [formControl]="fc_v6_51_handlungsbedarf" (change)="saveBSP()"></mat-checkbox>
            </td>
            <td class="cell2">6.51</td>
            <td class="cell3"
                >Entspricht die Einfriedung der Futtersilos dem Leitfaden „Einfriedung von Schweine haltenden
                Betrieben?“ …
            </td>
            <td class="cell4">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v6_51_antwort"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
            <td class="cell5">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v6_51_unterlage"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
        </tr>
        <tr class="table_row">
            <td class="cell1">
                <mat-checkbox [formControl]="fc_v6_52_handlungsbedarf" (change)="saveBSP()"></mat-checkbox>
            </td>
            <td class="cell2">6.52</td>
            <td class="cell3"
                >Falls betriebsfremde Fahrzeuge oder Personen das Betriebsgelände befahren/betreten müssen, gelten
                folgende Vorgaben zum Fahrzeug- und Personenverkehr auf dem Betriebsgelände:…
            </td>
            <td class="cell4">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v6_52_antwort"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
            <td class="cell5">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v6_52_unterlage"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
        </tr>
        <tr class="table_row">
            <td class="cell1">
                <mat-checkbox [formControl]="fc_v6_53_handlungsbedarf" (change)="saveBSP()"></mat-checkbox>
            </td>
            <td class="cell2">6.53</td>
            <td class="cell3"
                >Mit folgenden Maßnahmen stelle ich sicher, dass Futter und Einstreu vor Wildschweinen sicher geschützt
                ist (z. B. durch physischen Schutz wie Umzäunung, Einfriedung): …
            </td>
            <td class="cell4">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v6_53_antwort"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
            <td class="cell5">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v6_53_unterlage"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
        </tr>
        <tr class="table_row">
            <td class="cell1">
                <mat-checkbox [formControl]="fc_v6_54_handlungsbedarf" (change)="saveBSP()"></mat-checkbox>
            </td>
            <td class="cell2">6.54</td>
            <td class="cell3"
                >In die Ställe wird nur in Bezug auf gelistete Tierseuchen (insbesondere ASP) – nach bestem Wissen –
                unbedenkliches „Naturmaterial" (Silage, Heu, Gras, Erde etc.) verbracht.
            </td>
            <td class="cell4">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v6_54_antwort"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
            <td class="cell5">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v6_54_unterlage"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
        </tr>
    </table>

    <!--    Seite 7-->
    <div class="one/row">
        <h2 class="margin-left">7. WIE GELANGEN FAHRZEUGE AUF DAS BETRIEBSGELÄNDE?</h2>
    </div>
    <table class="biosicherheitsplan">
        <tr class="sektion_header">
            <th class="head1">Handlungsbedarf</th>
            <th class="head2">Lfd.Nr.</th>
            <th class="head3">zu berücksichtigen</th>
            <th class="head4">Antworten, Anmerkungen</th>
            <th class="head5">Ergänzende Unterlagen</th>
        </tr>
        <tr class="table_row">
            <td class="cell1">
                <mat-checkbox [formControl]="fc_v7_55_handlungsbedarf" (change)="saveBSP()"></mat-checkbox>
            </td>
            <td class="cell2">7.55</td>
            <td class="cell3">
                <div>
                    <strong
                        >Ich stelle sicher, dass unbefugter Fahrzeugverkehr durch folgende Maßnahmen ferngehalten
                        wird:</strong
                    ><br />
                    <mat-checkbox [formControl]="fc_v7_55_einfriedung" (change)="saveBSP()"
                        >Umzäunung, Einfriedung
                    </mat-checkbox>
                    <br />
                    <mat-checkbox [formControl]="fc_v7_55_tore" (change)="saveBSP()">geschlossene Tore </mat-checkbox>
                    <br />
                    <mat-checkbox [formControl]="fc_v7_55_beschilderung" (change)="saveBSP()">
                        deutlich sichtbare Beschilderungen "Schweinebestand – für Unbefugte Betreten verboten" vor dem
                        Betriebsgelände
                    </mat-checkbox>
                    <br />
                    <mat-checkbox [formControl]="fc_v7_55_auslauf" (change)="saveBSP()"
                        >Auslauf- und Freilandhaltungen: deutlich sichtbare Beschilderungen "Schweinebestand – für
                        Unbefugte Betreten und Füttern verboten" vor dem Betriebsgelände
                    </mat-checkbox>
                    <br />
                    <mat-checkbox [formControl]="fc_v7_55_sonstiges" (change)="saveBSP()">…</mat-checkbox>
                </div>
            </td>
            <td class="cell4">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v7_55_antwort"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
            <td class="cell5">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v7_55_unterlage"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
        </tr>
        <tr class="table_row">
            <td class="cell1">
                <mat-checkbox [formControl]="fc_v7_56_handlungsbedarf" (change)="saveBSP()"></mat-checkbox>
            </td>
            <td class="cell2">7.56</td>
            <td class="cell3">
                Es gibt Aufzeichnungen über alle Transportmittel, die Zugang zum Betrieb erhalten haben. Diese
                Dokumentation erfolgt folgendermaßen: (ggf. nötig für Sperrzonen I, II, III gemäß DVO (EU) 2023/594)
            </td>
            <td class="cell4">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v7_56_antwort"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
            <td class="cell5">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v7_56_unterlage"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
        </tr>
        <tr class="table_row">
            <td class="cell1">
                <mat-checkbox [formControl]="fc_v7_57_handlungsbedarf" (change)="saveBSP()"></mat-checkbox>
            </td>
            <td class="cell2">7.57</td>
            <td class="cell3">
                Mein Betrieb verfügt über folgende Vorrichtung, die eine Reinigung und Desinfektion der Räder von
                Fahrzeugen ermöglicht. Die Vorrichtung befindet sich hier:
            </td>
            <td class="cell4">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v7_57_antwort"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
            <td class="cell5">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v7_57_unterlage"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
        </tr>
        <tr class="table_row">
            <td class="cell1">
                <mat-checkbox [formControl]="fc_v7_58_handlungsbedarf" (change)="saveBSP()"></mat-checkbox>
            </td>
            <td class="cell2">7.58</td>
            <td class="cell3">
                Fahrzeuge, Maschinen und sonstige Gerätschaften, die unmittelbar in der Schweinehaltung von
                verschiedenen Betrieben gemeinsam benutzt werden, werden jeweils im abgebenden Betrieb gereinigt und
                desinfiziert, bevor sie in einem anderen Betrieb eingesetzt werden. Dies wird wie folgt dokumentiert:
            </td>
            <td class="cell4">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v7_58_antwort"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
            <td class="cell5">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v7_58_unterlage"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
        </tr>
        <tr class="table_row">
            <td class="cell1">
                <mat-checkbox [formControl]="fc_v7_59_handlungsbedarf" (change)="saveBSP()"></mat-checkbox>
            </td>
            <td class="cell2">7.59</td>
            <td class="cell3">
                Wie stelle ich sicher, dass betriebseigene Fahrzeuge unmittelbar nach Abschluss der Tiertransporte
                vollständig auf einem befestigten Platz gereinigt und desinfiziert werden? Wie ist dabei das Vorgehen?
            </td>
            <td class="cell4">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v7_59_antwort"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
            <td class="cell5">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v7_59_unterlage"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
        </tr>
    </table>

    <!--    Seite 8-->
    <div class="one/row">
        <h2 class="margin-left">8. WIE GELANGEN PERSONEN IN MEINEN BETRIEB?</h2>
    </div>
    <div class="pdf-upload-container">
        <div>
            <input
                #fileInput8
                (change)="onFileChange($event, 'sektion8')"
                [disabled]="isLoadingOrSaving() || isReadOnly()"
                accept=".pdf"
                hidden
                type="file"
            />
            <button
                (click)="handleFileButtonClick(fileInput8)"
                [disabled]="isLoadingOrSaving() || isReadOnly()"
                color="primary"
                mat-stroked-button
            >
                Skizze der Hygieneschleuse als PDF hinzufügen
            </button>
        </div>

        <div class="chip-list-wrapper">
            <mat-chip-list aria-label="Pdf auswahl">
                <mat-chip
                    *ngFor="let biofile of getSektionFiles('sektion8')"
                    (click)="showFilePdf(biofile)"
                    [removable]="!isLoadingOrSaving() && !isReadOnly()"
                    (removed)="removeFile(biofile, 'sektion8')"
                    selectable="false"
                    matTooltip="{{ biofile?.dateiname || biofile?.file?.name }}"
                >
                    <mat-icon matChipAvatar>picture_as_pdf</mat-icon>
                    {{ biofile?.dateiname || biofile?.file?.name }}
                    <button
                        matChipRemove
                        *ngIf="!isLoadingOrSaving() && !isReadOnly()"
                        (click)="$event.stopPropagation()"
                    >
                        <mat-icon>cancel</mat-icon>
                    </button>
                </mat-chip>
            </mat-chip-list>
        </div>
    </div>

    <table class="biosicherheitsplan">
        <tr>
            <td class="sektion_headline" colspan="5">Skizze der Hygieneschleuse:</td>
        </tr>
        <tr class="sektion_header">
            <th class="head1">Handlungsbedarf</th>
            <th class="head2">Lfd.Nr.</th>
            <th class="head3">zu berücksichtigen</th>
            <th class="head4">Antworten, Anmerkungen</th>
            <th class="head5">Ergänzende Unterlagen</th>
        </tr>
        <tr class="table_row">
            <td class="cell1"></td>
            <td class="cell2">8.60</td>
            <td class="cell3"
                >Wo verläuft die Trennung rein/unrein? Wodurch ist sie gekennzeichnet? Optisch oder physisch (z. B. Bank
                zum Übertreten)?
            </td>
            <td class="cell4">
                <div style="width: 40%; height: 100%"></div>
                <mat-form-field style="width: 60%">
                    <textarea
                        [formControl]="fc_v8_60_antwort"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
            <td class="cell5">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v8_60_unterlage"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
        </tr>
        <tr class="table_row">
            <td class="cell1"></td>
            <td class="cell2">8.61</td>
            <td class="cell3">Wo werden die Straßenschuhe abgestellt?</td>
            <td class="cell4">
                <div style="width: 40%; height: 100%"></div>
                <mat-form-field style="width: 60%">
                    <textarea
                        [formControl]="fc_v8_61_antwort"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
            <td class="cell5">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v8_61_unterlage"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
        </tr>
        <tr class="table_row">
            <td class="cell1"></td>
            <td class="cell2">8.62</td>
            <td class="cell3">In welchen Schränken/Spinden wird die Straßenkleidung aufbewahrt?</td>
            <td class="cell4">
                <div style="width: 40%; height: 100%"></div>
                <mat-form-field style="width: 60%">
                    <textarea
                        [formControl]="fc_v8_62_antwort"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
            <td class="cell5">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v8_62_unterlage"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
        </tr>
        <tr class="table_row">
            <td class="cell1"></td>
            <td class="cell2">8.63</td>
            <td class="cell3">Wo wird betriebseigenes Schuhwerk gelagert? Wo wird es angezogen?</td>
            <td class="cell4">
                <div style="width: 40%; height: 100%"></div>
                <mat-form-field style="width: 60%">
                    <textarea
                        [formControl]="fc_v8_63_antwort"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
            <td class="cell5">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v8_63_unterlage"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
        </tr>
        <tr class="table_row">
            <td class="cell1"></td>
            <td class="cell2">8.64</td>
            <td class="cell3">Wo wird betriebseigene Schutzkleidung (auch Einwegkleidung) aufbewahrt?</td>
            <td class="cell4">
                <div style="width: 40%; height: 100%"></div>
                <mat-form-field style="width: 60%">
                    <textarea
                        [formControl]="fc_v8_64_antwort"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
            <td class="cell5">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v8_64_unterlage"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
        </tr>
        <tr class="table_row">
            <td class="cell1"></td>
            <td class="cell2">8.65</td>
            <td class="cell3">Wo sind Handwaschbecken (mit Seife)?</td>
            <td class="cell4">
                <div style="width: 40%; height: 100%"></div>
                <mat-form-field style="width: 60%">
                    <textarea
                        [formControl]="fc_v8_65_antwort"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
            <td class="cell5">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v8_65_unterlage"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
        </tr>
        <tr class="table_row">
            <td class="cell1"></td>
            <td class="cell2">8.66</td>
            <td class="cell3">Wo befindet sich Hand-Desinfektionsmittel?</td>
            <td class="cell4">
                <div style="width: 40%; height: 100%"></div>
                <mat-form-field style="width: 60%">
                    <textarea
                        [formControl]="fc_v8_66_antwort"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
            <td class="cell5">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v8_66_unterlage"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
        </tr>
        <tr class="table_row">
            <td class="cell1"></td>
            <td class="cell2">8.67</td>
            <td class="cell3">Wo befinden sich Wasseranschlüsse für die Reinigung des Schuhwerks?</td>
            <td class="cell4">
                <div style="width: 40%; height: 100%"></div>
                <mat-form-field style="width: 60%">
                    <textarea
                        [formControl]="fc_v8_67_antwort"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
            <td class="cell5">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v8_67_unterlage"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
        </tr>
        <tr class="table_row">
            <td class="cell1"></td>
            <td class="cell2">8.68</td>
            <td class="cell3"
                >Wo befindet sich eine Waschmaschine, in der betriebseigene Schutzkleidung gewaschen werden kann?
            </td>
            <td class="cell4">
                <div style="width: 40%; height: 100%"></div>
                <mat-form-field style="width: 60%">
                    <textarea
                        [formControl]="fc_v8_68_antwort"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
            <td class="cell5">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v8_68_unterlage"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
        </tr>
        <tr class="table_row">
            <td class="cell1"></td>
            <td class="cell2">8.69</td>
            <td class="cell3">Wo befindet sich der Mülleimer für Einwegkleidung?</td>
            <td class="cell4">
                <div style="width: 40%; height: 100%"></div>
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v8_69_antwort"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
            <td class="cell5">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v8_69_unterlage"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
        </tr>
        <tr class="table_row">
            <td class="cell1"></td>
            <td class="cell2">8.70</td>
            <td class="cell3">Wo befindet sich das Besucherbuch?</td>
            <td class="cell4">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v8_70_antwort"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
            <td class="cell5">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v8_70_unterlage"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
        </tr>
        <tr class="table_row">
            <td class="cell1"></td>
            <td class="cell2">8.71</td>
            <td class="cell3">Sonstiges, z. B. Sperma-/Kühlschrank, Durchreiche, etc</td>
            <td class="cell4">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v8_71_antwort"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
            <td class="cell5">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v8_71_unterlage"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
        </tr>
        <tr class="table_row">
            <td class="cell1"></td>
            <td class="cell2">8.72</td>
            <td class="cell3">Sonstiges, z. B. Dusche, WC etc.</td>
            <td class="cell4">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v8_72_antwort"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
            <td class="cell5">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v8_72_unterlage"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
        </tr>
        <tr class="table_row">
            <td class="cell1">
                <mat-checkbox [formControl]="fc_v8_73_handlungsbedarf" (change)="saveBSP()"></mat-checkbox>
            </td>
            <td class="cell2">8.73</td>
            <td class="cell3">
                <div>
                    <strong
                        >Ich stelle sicher, dass unbefugte Personen durch folgende Maßnahmen ferngehalten
                        werden:</strong
                    ><br />
                    <mat-checkbox [formControl]="fc_v8_73_einfriedung" (change)="saveBSP()"
                        >Umzäunung, Einfriedung
                    </mat-checkbox>
                    <br />
                    <mat-checkbox [formControl]="fc_v8_73_geschlossen" (change)="saveBSP()"
                        >geschlossene Tore
                    </mat-checkbox>
                    <br />
                    <mat-checkbox [formControl]="fc_v8_73_beschilderung" (change)="saveBSP()">
                        deutlich sichtbare Beschilderungen "Schweinebestand – für Unbefugte Betreten verboten" vor dem
                        Betriebsgelände
                    </mat-checkbox>
                    <br />
                    <mat-checkbox [formControl]="fc_v8_73_auslauf" (change)="saveBSP()"
                        >Auslauf- und Freilandhaltungen: deutlich sichtbare Beschilderungen "Schweinebestand – für
                        Unbefugte Betreten und Füttern verboten" vor dem Betriebsgelände
                    </mat-checkbox>
                    <br />
                    <mat-checkbox [formControl]="fc_v8_73_sonstiges" (change)="saveBSP()">…</mat-checkbox>
                </div>
            </td>
            <td class="cell4">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v8_73_antwort"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
            <td class="cell5">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v8_73_unterlage"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
        </tr>
        <tr class="table_row">
            <td class="cell1">
                <mat-checkbox [formControl]="fc_v8_74_handlungsbedarf" (change)="saveBSP()"></mat-checkbox>
            </td>
            <td class="cell2">8.74</td>
            <td class="cell3"> Für Besucher stehen folgende ausgewiesene Parkmöglichkeiten zur Verfügung: …</td>
            <td class="cell4">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v8_74_antwort"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
            <td class="cell5">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v8_74_unterlage"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
        </tr>
        <tr class="table_row">
            <td class="cell1">
                <mat-checkbox [formControl]="fc_v8_75_handlungsbedarf" (change)="saveBSP()"></mat-checkbox>
            </td>
            <td class="cell2">8.75</td>
            <td class="cell3">
                Alle im Betrieb tätigen Personen sind in Hinblick auf Hygiene und Biosicherheit unterwiesen und werden
                regelmäßig geschult (Sensibilisierungsprogramm). Dies stelle ich folgendermaßen sicher: ..
            </td>
            <td class="cell4">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v8_75_antwort"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
            <td class="cell5">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v8_75_unterlage"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
        </tr>
        <tr class="table_row">
            <td class="cell1">
                <mat-checkbox [formControl]="fc_v8_76_handlungsbedarf" (change)="saveBSP()"></mat-checkbox>
            </td>
            <td class="cell2">8.76</td>
            <td class="cell3">
                Alle im Betrieb tätigen Personen betreten und verlassen den Weißbereich nur durch korrekte Nutzung der
                Hygieneschleuse. Dies stelle ich wie folgt sicher: ...
            </td>
            <td class="cell4">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v8_76_antwort"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
            <td class="cell5">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v8_76_unterlage"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
        </tr>
        <tr class="table_row">
            <td class="cell1">
                <mat-checkbox [formControl]="fc_v8_77_handlungsbedarf" (change)="saveBSP()"></mat-checkbox>
            </td>
            <td class="cell2">8.77</td>
            <td class="cell3">
                Der Tierbereich wird von betriebsfremden Personen nur in Abstimmung mit mir und nach Unterweisung in der
                betriebsspezifischen Hygiene und Biosicherheit betreten. Dies stelle ich wie folgt sicher: …
            </td>
            <td class="cell4">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v8_77_antwort"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
            <td class="cell5">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v8_77_unterlage"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
        </tr>
        <tr class="table_row">
            <td class="cell1">
                <mat-checkbox [formControl]="fc_v8_78_handlungsbedarf" (change)="saveBSP()"></mat-checkbox>
            </td>
            <td class="cell2">8.78</td>
            <td class="cell3">
                Die im Betrieb zum Bau oder zur Instandsetzung tätigen Personen werden wie andere Besucher in Hinblick
                auf Hygiene und Biosicherheit unterwiesen. Es wird folgendermaßen sichergestellt, dass auch bei diesem
                Personenkreis jedes Betreten und Verlassen des Weißbereichs nur über die korrekte Nutzung der
                Hygieneschleuse erfolgt und dass notwendigerweise mitgebrachte Werkzeuge gereinigt und desinfiziert
                sind: …
            </td>
            <td class="cell4">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v8_78_antwort"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
            <td class="cell5">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v8_78_unterlage"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
        </tr>
        <tr class="table_row">
            <td class="cell1">
                <mat-checkbox [formControl]="fc_v8_79_handlungsbedarf" (change)="saveBSP()"></mat-checkbox>
            </td>
            <td class="cell2">8.79</td>
            <td class="cell3"> Es wird ein Besucherbuch/-liste geführt. Dieses befindet sich hier: …</td>
            <td class="cell4">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v8_79_antwort"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
            <td class="cell5">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v8_79_unterlage"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
        </tr>
        <tr class="table_row">
            <td class="cell1">
                <mat-checkbox [formControl]="fc_v8_80_handlungsbedarf" (change)="saveBSP()"></mat-checkbox>
            </td>
            <td class="cell2">8.80</td>
            <td class="cell3">
                Der Zugang von Personen zum Tierbereich ist nur über die Hygieneschleuse möglich. Diese befindet sich
                hier: …
            </td>
            <td class="cell4">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v8_80_antwort"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
            <td class="cell5">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v8_80_unterlage"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
        </tr>
        <tr class="table_row">
            <td class="cell1">
                <mat-checkbox [formControl]="fc_v8_81_handlungsbedarf" (change)="saveBSP()"></mat-checkbox>
            </td>
            <td class="cell2">8.81</td>
            <td class="cell3">
                Die Ein- und Ausgänge der Ställe oder der sonstigen Standorte sind mit folgenden Vorrichtungen versehen,
                die eine Reinigung und Desinfektion des Schuhzeugs ermöglichen: …
            </td>
            <td class="cell4">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v8_81_antwort"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
            <td class="cell5">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v8_81_unterlage"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
        </tr>
        <tr class="table_row">
            <td class="cell1">
                <mat-checkbox [formControl]="fc_v8_82_handlungsbedarf" (change)="saveBSP()"></mat-checkbox>
            </td>
            <td class="cell2">8.82</td>
            <td class="cell3">
                Ich stelle wie folgt sicher, dass der Tierbereich von betriebsfremden Personen nur mit Einwegkleidung
                oder betriebseigener Schutzkleidung betreten wird und diese Personen die Schutzkleidung nach Verlassen
                der Tierbereiche ablegen: ...
            </td>
            <td class="cell4">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v8_82_antwort"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
            <td class="cell5">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v8_82_unterlage"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
        </tr>
        <tr class="table_row">
            <td class="cell1">
                <mat-checkbox [formControl]="fc_v8_83_handlungsbedarf" (change)="saveBSP()"></mat-checkbox>
            </td>
            <td class="cell2">8.83</td>
            <td class="cell3">
                Straßenkleidung und betriebseigene Schutzkleidung werden in folgenden Vorrichtungen getrennt voneinander
                aufbewahrt: …
            </td>
            <td class="cell4">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v8_83_antwort"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
            <td class="cell5">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v8_83_unterlage"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
        </tr>
        <tr class="table_row">
            <td class="cell1">
                <mat-checkbox [formControl]="fc_v8_84_handlungsbedarf" (change)="saveBSP()"></mat-checkbox>
            </td>
            <td class="cell2">8.84</td>
            <td class="cell3"> Das Schwarz-Weiß-Prinzip beim Personenverkehr wird dadurch eingehalten, dass …</td>
            <td class="cell4">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v8_84_antwort"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
            <td class="cell5">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v8_84_unterlage"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
        </tr>
        <tr class="table_row">
            <td class="cell1">
                <mat-checkbox [formControl]="fc_v8_85_handlungsbedarf" (change)="saveBSP()"></mat-checkbox>
            </td>
            <td class="cell2">8.85</td>
            <td class="cell3">
                Ich stelle sicher, dass im Betrieb jederzeit ausreichend Einwegkleidung oder betriebseigene und
                gereinigte Schutzkleidung zur Verfügung steht.
            </td>
            <td class="cell4">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v8_85_antwort"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
            <td class="cell5">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v8_85_unterlage"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
        </tr>
        <tr class="table_row">
            <td class="cell1">
                <mat-checkbox [formControl]="fc_v8_86_handlungsbedarf" (change)="saveBSP()"></mat-checkbox>
            </td>
            <td class="cell2">8.86</td>
            <td class="cell3">
                Ich stelle sicher, dass das Schuhzeug regelmäßig in folgenden Abständen und folgender Art und Weise
                gereinigt und desinfiziert wird: …
            </td>
            <td class="cell4">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v8_86_antwort"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
            <td class="cell5">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v8_86_unterlage"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
        </tr>
        <tr class="table_row">
            <td class="cell1">
                <mat-checkbox [formControl]="fc_v8_87_handlungsbedarf" (change)="saveBSP()"></mat-checkbox>
            </td>
            <td class="cell2">8.87</td>
            <td class="cell3">
                Schutzkleidung, die wiederverwendet werden soll, wird regelmäßig (Intervall?) bei mindestens 60°C
                gewaschen.
                <br />
                <mat-checkbox [formControl]="fc_v8_87_schleuse" (change)="saveBSP()"
                    >Die Waschmaschine befindet sich im Bereich der Hygieneschleuse.
                </mat-checkbox>
                <br />
                <mat-checkbox [formControl]="fc_v8_87_ort_schleuse" (change)="saveBSP()"
                    >Die Waschmaschine befindet sich an folgendem Ort: …
                </mat-checkbox>
            </td>
            <td class="cell4">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v8_87_antwort"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
            <td class="cell5">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v8_87_unterlage"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
        </tr>
        <tr class="table_row">
            <td class="cell1">
                <mat-checkbox [formControl]="fc_v8_88_handlungsbedarf" (change)="saveBSP()"></mat-checkbox>
            </td>
            <td class="cell2">8.88</td>
            <td class="cell3"> Einwegschutzkleidung wird nach Gebrauch wie folgt unschädlich entsorgt: …</td>
            <td class="cell4">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v8_88_antwort"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
            <td class="cell5">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v8_88_unterlage"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
        </tr>
        <tr class="table_row">
            <td class="cell1">
                <mat-checkbox [formControl]="fc_v8_89_handlungsbedarf" (change)="saveBSP()"></mat-checkbox>
            </td>
            <td class="cell2">8.89</td>
            <td class="cell3">
                In Sperrzonen I, II, III gemäß DVO (EU) 2023/594) gilt ggf.:In den 48 Stunden vor Betreten des
                Tierbereiches dürfen keine Jagdtätigkeiten im Zusammenhang mit Wildschweinen oder sonstiger Kontakt zu
                Wildschweinen stattgefunden haben. Dies stelle ich wie folgt sicher: …
            </td>
            <td class="cell4">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v8_89_antwort"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
            <td class="cell5">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v8_89_unterlage"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
        </tr>
    </table>

    <!--    Seite 9-->
    <div class="one/row">
        <h2 class="margin-left">9. VERFAHREN FÜR DIE NUTZUNG VON AUSRÜSTUNG</h2>
    </div>
    <table class="biosicherheitsplan">
        <tr class="sektion_header">
            <th class="head1">Handlungsbedarf</th>
            <th class="head2">Lfd.Nr.</th>
            <th class="head3">zu berücksichtigen</th>
            <th class="head4">Antworten, Anmerkungen</th>
            <th class="head5">Ergänzende Unterlagen</th>
        </tr>
        <tr class="table_row">
            <td class="cell1">
                <mat-checkbox [formControl]="fc_v9_90_handlungsbedarf" (change)="saveBSP()"></mat-checkbox>
            </td>
            <td class="cell2">9.90</td>
            <td class="cell3">
                Betriebseigene Ausrüstung wird in folgenden Abständen gemäß dem R+D Plan gereinigt und desinfiziert und
                auf Funktionsfähigkeit überprüft: …
            </td>
            <td class="cell4">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v9_90_antwort"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
            <td class="cell5">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v9_90_unterlage"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
        </tr>
        <tr class="table_row">
            <td class="cell1">
                <mat-checkbox [formControl]="fc_v9_91_handlungsbedarf" (change)="saveBSP()"></mat-checkbox>
            </td>
            <td class="cell2">9.91</td>
            <td class="cell3">
                Fahrzeuge, Maschinen und sonstige Gerätschaften, die unmittelbar in der Schweinehaltung von
                verschiedenen Betrieben gemeinsam benutzt werden, werden jeweils im abgebenden Betrieb gereinigt und
                desinfiziert, bevor sie in einem anderen Betrieb eingesetzt werden. Dies stelle ich wie folgt sicher: …
            </td>
            <td class="cell4">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v9_91_antwort"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
            <td class="cell5">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v9_91_unterlage"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
        </tr>
    </table>

    <!--    Seite 10-->
    <div class="one/row">
        <h2 class="margin-left">10. ÜBERWACHUNG DER TIERGESUNDHEIT</h2>
    </div>
    <table class="biosicherheitsplan">
        <tr class="sektion_header">
            <th class="head1">Handlungsbedarf</th>
            <th class="head2">Lfd.Nr.</th>
            <th class="head3">zu berücksichtigen</th>
            <th class="head4">Antworten, Anmerkungen</th>
            <th class="head5">Ergänzende Unterlagen</th>
        </tr>
        <tr class="table_row">
            <td class="cell1">
                <mat-checkbox [formControl]="fc_v10_92_handlungsbedarf" (change)="saveBSP()"></mat-checkbox>
            </td>
            <td class="cell2">10.92</td>
            <td class="cell3">
                <div>
                    Es liegen folgende Dokumentationen vor:<br />
                    <mat-checkbox [formControl]="fc_v10_92_bestandsregister" (change)="saveBSP()">
                        Bestandsregister
                    </mat-checkbox>
                    <br />
                    <mat-checkbox [formControl]="fc_v10_92_berechnung_verluste" (change)="saveBSP()"
                        >Berechnung der Verluste / Kümmerer / kranken Tiere erfolgt regelmäßig, • mindestens jedoch
                        ........... / wöchentlich • mit Hilfe:
                    </mat-checkbox>
                    <br />
                    <mat-checkbox [formControl]="fc_v10_92_sauenplaner" style="margin-left: 48px" (change)="saveBSP()">
                        Sauenplaner …
                    </mat-checkbox>
                    <br />
                    <mat-checkbox [formControl]="fc_v10_92_mastplaner" style="margin-left: 48px" (change)="saveBSP()">
                        Mastplaner…
                    </mat-checkbox>
                    <br />
                    <mat-checkbox
                        [formControl]="fc_v10_92_nach_aufzeichnungen"
                        style="margin-left: 48px"
                        (change)="saveBSP()"
                        >folgender Aufzeichnungen …
                    </mat-checkbox>
                </div>
            </td>
            <td class="cell4">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v10_92_antwort"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
            <td class="cell5">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v10_92_unterlage"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
        </tr>
        <tr class="table_row">
            <td class="cell1">
                <mat-checkbox [formControl]="fc_v10_93_handlungsbedarf" (change)="saveBSP()"></mat-checkbox>
            </td>
            <td class="cell2">10.93</td>
            <td class="cell3">
                <div>
                    Berechnung der Umrauschquote / Aborte erfolgt regelmäßig, <br />
                    <mat-checkbox [formControl]="fc_v10_93_mindestens" (change)="saveBSP()"
                        >mindestens jedoch ........... / wöchentlich
                    </mat-checkbox>
                    <br />
                    <mat-checkbox [formControl]="fc_v10_93_mit_hilfe" (change)="saveBSP()"
                        >mit Hilfe: • Sauenplaner … • …
                    </mat-checkbox>
                </div>
            </td>
            <td class="cell4">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v10_93_antwort"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
            <td class="cell5">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v10_93_unterlage"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
        </tr>
        <tr class="table_row">
            <td class="cell1">
                <mat-checkbox [formControl]="fc_v10_94_handlungsbedarf" (change)="saveBSP()"></mat-checkbox>
            </td>
            <td class="cell2">10.94</td>
            <td class="cell3"> Die tägliche Kontrolle der Bestandsgesundheit ist folgendermaßen organisiert: …</td>
            <td class="cell4">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v10_94_antwort"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
            <td class="cell5">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v10_94_unterlage"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
        </tr>
        <tr class="table_row">
            <td class="cell1">
                <mat-checkbox [formControl]="fc_v10_95_handlungsbedarf" (change)="saveBSP()"></mat-checkbox>
            </td>
            <td class="cell2">10.95</td>
            <td class="cell3"> Die tägliche Kontrolle der Futteraufnahme ist folgendermaßen organisiert: …</td>
            <td class="cell4">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v10_95_antwort"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
            <td class="cell5">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v10_95_unterlage"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
        </tr>
        <tr class="table_row">
            <td class="cell1">
                <mat-checkbox [formControl]="fc_v10_96_handlungsbedarf" (change)="saveBSP()"></mat-checkbox>
            </td>
            <td class="cell2">10.96</td>
            <td class="cell3">
                Wenn ich erhöhte Werte der o.g. Parameter feststelle, informiere ich meine Tierarztpraxis und ggf. das
                Veterinäramt
            </td>
            <td class="cell4">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v10_96_antwort"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
            <td class="cell5">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v10_96_unterlage"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
        </tr>
        <tr class="table_row">
            <td class="cell1">
                <mat-checkbox [formControl]="fc_v10_97_handlungsbedarf" (change)="saveBSP()"></mat-checkbox>
            </td>
            <td class="cell2">10.97</td>
            <td class="cell3">
                Ich stelle mit folgenden Maßnahmen sicher, dass aus meinem Bestand keine Tiere verbracht werden, wenn
                vermehrt tote Tiere anfallen, vermehrt kranke Tiere vorhanden sind oder andere Symptome auf den
                möglichen Eintrag einer Tierseuche hindeuten (z.B.: Verladetermin absagen, verantwortliche Personen
                informieren etc.): …
            </td>
            <td class="cell4">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v10_97_antwort"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
            <td class="cell5">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v10_97_unterlage"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
        </tr>
        <tr class="table_row">
            <td class="cell1">
                <mat-checkbox [formControl]="fc_v10_98_handlungsbedarf" (change)="saveBSP()"></mat-checkbox>
            </td>
            <td class="cell2">10.98</td>
            <td class="cell3">
                Die tierärztliche Bestandsbetreuung (nach den Maßgaben der SchHaltHygV) erfolgt regelmäßig:<br />
                • mindestens zwei Mal jährlich / einmal pro Mastdurchgang<br />
                • in folgenden Abständen: …
            </td>
            <td class="cell4">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v10_98_antwort"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
            <td class="cell5">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v10_98_unterlage"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
        </tr>
        <tr class="table_row">
            <td class="cell1">
                <mat-checkbox [formControl]="fc_v10_99_handlungsbedarf" (change)="saveBSP()"></mat-checkbox>
            </td>
            <td class="cell2">10.99</td>
            <td class="cell3">
                Für den Fall der Abwesenheit des Verantwortlichen für die o.g. Punkte liegt ein Vertretungsplan vor.
                Dieser befindet sich an folgender Stelle: …
            </td>
            <td class="cell4">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v10_99_antwort"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
            <td class="cell5">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v10_99_unterlage"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
        </tr>
    </table>

    <!--    Seite 11-->
    <div class="one/row">
        <h2 class="margin-left">11. QUARANTÄNE, ISOLATION VON NEU EINGESTELLTEN TIEREN</h2>
    </div>
    <table class="biosicherheitsplan">
        <tr class="sektion_header">
            <th class="head1">Handlungsbedarf</th>
            <th class="head2">Lfd.Nr.</th>
            <th class="head3">zu berücksichtigen</th>
            <th class="head4">Antworten, Anmerkungen</th>
            <th class="head5">Ergänzende Unterlagen</th>
        </tr>
        <tr class="table_row">
            <td class="cell1">
                <mat-checkbox [formControl]="fc_v11_100_handlungsbedarf" (change)="saveBSP()"></mat-checkbox>
            </td>
            <td class="cell2">11.100</td>
            <td class="cell3">
                <div>
                    <strong
                        >In meinem Betrieb kann auf die Isolation neu eingestellter Tiere verzichtet werden, da eine der
                        folgenden Bedingungen erfüllt wird:</strong
                    >
                    <br />
                    <mat-checkbox [formControl]="fc_v11_100_mastbetrieb" (change)="saveBSP()"
                        >Mastbetrieb oder Aufzuchtbetrieb mit Rein-RausSystem
                    </mat-checkbox>
                    <br />
                    <mat-checkbox [formControl]="fc_v11_100_zusammenschluss" (change)="saveBSP()"
                        >Betrieb, der sich mit anderen Betrieben zu einer arbeitsteiligen Ferkelproduktion
                        zusammengeschlossen hat
                    </mat-checkbox>
                    <br />
                    <mat-checkbox [formControl]="fc_v11_100_ab_stall" (change)="saveBSP()"
                        >Betrieb, der nachweisbar Schweine direkt ab Stall und ohne Zuladung bezieht
                    </mat-checkbox>
                </div>
            </td>
            <td class="cell4">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v11_100_antwort"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
            <td class="cell5">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v11_100_unterlage"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
        </tr>
        <tr class="table_row">
            <td class="cell1">
                <mat-checkbox [formControl]="fc_v11_101_handlungsbedarf" (change)="saveBSP()"></mat-checkbox>
            </td>
            <td class="cell2">11.101</td>
            <td class="cell3">
                Geeignete Isolierställe für neu eingestallte Tiere sind an folgenden Stellen vorhanden: …
            </td>
            <td class="cell4">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v11_101_antwort"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
            <td class="cell5">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v11_101_unterlage"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
        </tr>
        <tr class="table_row">
            <td class="cell1">
                <mat-checkbox [formControl]="fc_v11_102_handlungsbedarf" (change)="saveBSP()"></mat-checkbox>
            </td>
            <td class="cell2">11.102</td>
            <td class="cell3"> Die Isolierställe haben folgende Kapazität: …</td>
            <td class="cell4">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v11_102_antwort"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
            <td class="cell5">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v11_102_unterlage"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
        </tr>
        <tr class="table_row">
            <td class="cell1">
                <mat-checkbox [formControl]="fc_v11_103_handlungsbedarf" (change)="saveBSP()"></mat-checkbox>
            </td>
            <td class="cell2">11.103</td>
            <td class="cell3">
                Gesonderte Schutzkleidung, Gerätschaften und Gegenstände für den Isolierstall sind an folgenden Stellen
                vorhanden: …
            </td>
            <td class="cell4">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v11_103_antwort"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
            <td class="cell5">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v11_103_unterlage"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
        </tr>
        <tr class="table_row">
            <td class="cell1">
                <mat-checkbox [formControl]="fc_v11_104_handlungsbedarf" (change)="saveBSP()"></mat-checkbox>
            </td>
            <td class="cell2">11.104</td>
            <td class="cell3">
                Durch folgende Maßnahmen stelle ich sicher, dass diese nur im Isolierstall verwendet und nach Verwendung
                ordnungsgemäß gereinigt und desinfiziert werden: …
            </td>
            <td class="cell4">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v11_104_antwort"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
            <td class="cell5">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v11_104_unterlage"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
        </tr>
        <tr class="table_row">
            <td class="cell1">
                <mat-checkbox [formControl]="fc_v11_105_handlungsbedarf" (change)="saveBSP()"></mat-checkbox>
            </td>
            <td class="cell2">11.105</td>
            <td class="cell3">
                Sämtliche Schweine werden vor der Einstallung ordnungsgemäß für mindestens drei Wochen in einem
                Isolierstall gehalten (Quarantäne). Dieses stelle ich wie folgt sicher: …
            </td>
            <td class="cell4">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v11_105_antwort"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
            <td class="cell5">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v11_105_unterlage"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
        </tr>
        <tr class="table_row">
            <td class="cell1">
                <mat-checkbox [formControl]="fc_v11_106_handlungsbedarf" (change)="saveBSP()"></mat-checkbox>
            </td>
            <td class="cell2">11.106</td>
            <td class="cell3">
                Beginn, Verlauf und Ende der Absonderung im Isolierstall werden wie folgt dokumentiert: …
            </td>
            <td class="cell4">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v11_106_antwort"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
            <td class="cell5">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v11_106_unterlage"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
        </tr>
        <tr class="table_row">
            <td class="cell1">
                <mat-checkbox [formControl]="fc_v11_107_handlungsbedarf" (change)="saveBSP()"></mat-checkbox>
            </td>
            <td class="cell2">11.107</td>
            <td class="cell3">
                Aus dem Isolierstall werden Tiere nur verbracht, wenn alle Tiere frei von Krankheitsanzeichen sind, die
                auf eine anzeigepflichtige Tierseuche hindeuten, zu diagnostischen Zwecken oder zur Tötung und zur
                unschädlichen Beseitigung.
            </td>
            <td class="cell4">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v11_107_antwort"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
            <td class="cell5">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v11_107_unterlage"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
        </tr>
        <tr class="table_row">
            <td class="cell1">
                <mat-checkbox [formControl]="fc_v11_108_handlungsbedarf" (change)="saveBSP()"></mat-checkbox>
            </td>
            <td class="cell2">11.108</td>
            <td class="cell3">
                Zwischen der Ausstallung und der Wiederbelegung wird der freigewordene Isolierstall einschließlich der
                vorhandenen Einrichtungen und Gegenstände gereinigt und desinfiziert. Dies wird wie folgt dokumentiert:
                …
            </td>
            <td class="cell4">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v11_108_antwort"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
            <td class="cell5">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v11_108_unterlage"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
        </tr>
        <tr class="table_row">
            <td class="cell1">
                <mat-checkbox [formControl]="fc_v11_109_handlungsbedarf" (change)="saveBSP()"></mat-checkbox>
            </td>
            <td class="cell2">11.109</td>
            <td class="cell3">
                Die Absonderung erfolgt im Isolierstall des Zulieferbetriebes. Es wird sichergestellt, dass dieser nicht
                gleichzeitig für neu eingestallte Schweine genutzt wird und der anschließende Transport zum
                Empfängerbetrieb auf direktem Wege und ohne Kontakt zu Schweinen anderer Herkunft in zuvor gereinigten
                und desinfizierten Fahrzeugen erfolgt. Dieses Vorgehen lasse ich mir wie folgt bescheinigen: …
            </td>
            <td class="cell4">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v11_109_antwort"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
            <td class="cell5">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v11_109_unterlage"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
        </tr>
    </table>

    <!--    Seite 12-->
    <div class="one/row">
        <h2 class="margin-left">12. QUARANTÄNE, ISOLATION ODER ABSONDERUNG VON KRANKEN TIEREN</h2>
    </div>
    <table class="biosicherheitsplan">
        <tr class="sektion_header">
            <th class="head1">Handlungsbedarf</th>
            <th class="head2">Lfd.Nr.</th>
            <th class="head3">zu berücksichtigen</th>
            <th class="head4">Antworten, Anmerkungen</th>
            <th class="head5">Ergänzende Unterlagen</th>
        </tr>
        <tr class="table_row">
            <td class="cell1">
                <mat-checkbox [formControl]="fc_v12_110_handlungsbedarf" (change)="saveBSP()"></mat-checkbox>
            </td>
            <td class="cell2">12.110</td>
            <td class="cell3">
                Wo sind Krankenbuchten zur Absonderung kranker Schweine eingerichtet? Je Abteil? Je Stall? Wie groß, wie
                viele? …
            </td>
            <td class="cell4">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v12_110_antwort"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
            <td class="cell5">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v12_110_unterlage"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
        </tr>
        <tr class="table_row">
            <td class="cell1">
                <mat-checkbox [formControl]="fc_v12_111_handlungsbedarf" (change)="saveBSP()"></mat-checkbox>
            </td>
            <td class="cell2">12.111</td>
            <td class="cell3">
                Die Krankenbucht steht jederzeit für abzusondernde/ kranke Tiere zur Verfügung und wird nicht
                zweckentfremdet.
            </td>
            <td class="cell4">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v12_111_antwort"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
            <td class="cell5">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v12_111_unterlage"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
        </tr>
        <tr class="table_row">
            <td class="cell1">
                <mat-checkbox [formControl]="fc_v12_112_handlungsbedarf" (change)="saveBSP()"></mat-checkbox>
            </td>
            <td class="cell2">12.112</td>
            <td class="cell3">
                Bei der Betreuung der Tiere achte ich darauf, die Krankenbucht erst am Ende des Durchgangs zu betreten.
            </td>
            <td class="cell4">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v12_112_antwort"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
            <td class="cell5">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v12_112_unterlage"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
        </tr>
        <tr class="table_row">
            <td class="cell1">
                <mat-checkbox [formControl]="fc_v12_113_handlungsbedarf" (change)="saveBSP()"></mat-checkbox>
            </td>
            <td class="cell2">12.113</td>
            <td class="cell3">
                Bei Gefahr der Erregerverschleppung stelle ich durch folgende Maßnahmen sicher, dass separate
                Schutzkleidung, Gerätschaften und Gegenstände für die Krankenbucht vorhanden sind, die nur dort
                verwendet werden bzw. nach Verwendung ordnungsgemäß gereinigt und desinfiziert werden: …
            </td>
            <td class="cell4">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v12_113_antwort"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
            <td class="cell5">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v12_113_unterlage"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
        </tr>
        <tr class="table_row">
            <td class="cell1">
                <mat-checkbox [formControl]="fc_v12_114_handlungsbedarf" (change)="saveBSP()"></mat-checkbox>
            </td>
            <td class="cell2">12.114</td>
            <td class="cell3">
                Zwischen der Ausstallung und der Wiederbelegung wird die freigewordene Krankenbucht einschließlich der
                vorhandenen Einrichtungen und Gegenstände wie folgt gereinigt und desinfiziert: ...
            </td>
            <td class="cell4">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v12_114_antwort"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
            <td class="cell5">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v12_114_unterlage"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
        </tr>
    </table>

    <!--    Seite 13-->
    <div class="one/row">
        <h2 class="margin-left">13. SYSTEM FÜR DIE SICHERE BESEITIGUNG TOTER TIERE</h2>
    </div>
    <table class="biosicherheitsplan">
        <tr class="sektion_header">
            <th class="head1">Handlungsbedarf</th>
            <th class="head2">Lfd.Nr.</th>
            <th class="head3">zu berücksichtigen</th>
            <th class="head4">Antworten, Anmerkungen</th>
            <th class="head5">Ergänzende Unterlagen</th>
        </tr>
        <tr class="table_row">
            <td class="cell1">
                <mat-checkbox [formControl]="fc_v13_115_handlungsbedarf" (change)="saveBSP()"></mat-checkbox>
            </td>
            <td class="cell2">13.115</td>
            <td class="cell3">
                Die unmittelbare Entfernung verendeter Schweine aus dem Tierbereich stelle ich wie folgt sicher: …
            </td>
            <td class="cell4">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v13_115_antwort"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
            <td class="cell5">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v13_115_unterlage"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
        </tr>
        <tr class="table_row">
            <td class="cell1">
                <mat-checkbox [formControl]="fc_v13_116_handlungsbedarf" (change)="saveBSP()"></mat-checkbox>
            </td>
            <td class="cell2">13.116</td>
            <td class="cell3"> Verendete Schweine werden in folgendem Behälter aufbewahrt: ..</td>
            <td class="cell4">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v13_116_antwort"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
            <td class="cell5">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v13_116_unterlage"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
        </tr>
        <tr class="table_row">
            <td class="cell1">
                <mat-checkbox [formControl]="fc_v13_117_handlungsbedarf" (change)="saveBSP()"></mat-checkbox>
            </td>
            <td class="cell2">13.117</td>
            <td class="cell3">
                Der Behälter ist kompatibel mit Fahrzeugen der Verarbeitungsbetriebe für tierische Nebenprodukte der
                Firma … Die Anmeldung der toten Tiere bei o.g. Verarbeitungsbetrieb wird nach folgendem System
                durchgeführt: ...
            </td>
            <td class="cell4">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v13_117_antwort"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
            <td class="cell5">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v13_117_unterlage"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
        </tr>
        <tr class="table_row">
            <td class="cell1">
                <mat-checkbox [formControl]="fc_v13_118_handlungsbedarf" (change)="saveBSP()"></mat-checkbox>
            </td>
            <td class="cell2">13.118</td>
            <td class="cell3">
                Die Abholung von Kadavern erfolgt ohne Befahren des Betriebsgeländes über folgenden Bereich: ...
            </td>
            <td class="cell4">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v13_118_antwort"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
            <td class="cell5">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v13_118_unterlage"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
        </tr>
        <tr class="table_row">
            <td class="cell1">
                <mat-checkbox [formControl]="fc_v13_119_handlungsbedarf" (change)="saveBSP()"></mat-checkbox>
            </td>
            <td class="cell2">13.119</td>
            <td class="cell3">
                Ich stelle sicher, dass der Raum, der Behälter oder die sonstigen Einrichtungen zur Aufbewahrung
                verendeter Schweine nach jeder Entleerung umgehend gereinigt und desinfiziert werden, indem ich …
            </td>
            <td class="cell4">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v13_119_antwort"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
            <td class="cell5">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v13_119_unterlage"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
        </tr>
    </table>

    <!--    Seite 14-->
    <div class="one/row">
        <h2 class="margin-left">14. SYSTEM FÜR DIE SICHERE BESEITIGUNG ANDERER TIERISCHER NEBENPRODUKTE</h2>
    </div>
    <table class="biosicherheitsplan">
        <tr class="sektion_header">
            <th class="head1">Handlungsbedarf</th>
            <th class="head2">Lfd.Nr.</th>
            <th class="head3">zu berücksichtigen</th>
            <th class="head4">Antworten, Anmerkungen</th>
            <th class="head5">Ergänzende Unterlagen</th>
        </tr>
        <tr class="table_row">
            <td class="cell1">
                <mat-checkbox [formControl]="fc_v14_120_handlungsbedarf" (change)="saveBSP()"></mat-checkbox>
            </td>
            <td class="cell2">14.120</td>
            <td class="cell3">
                bei Einstreuhaltung: System des Ausmistens? Intervall? Hilfsmittel? Transport zum Lagerplatz?
            </td>
            <td class="cell4">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v14_120_antwort"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
            <td class="cell5">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v14_120_unterlage"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
        </tr>
        <tr class="table_row">
            <td class="cell1">
                <mat-checkbox [formControl]="fc_v14_121_handlungsbedarf" (change)="saveBSP()"></mat-checkbox>
            </td>
            <td class="cell2">14.121</td>
            <td class="cell3">
                Es bestehen folgende Lagermöglichkeiten für Mist und Gülle vor dem Verbringen aus dem Betrieb: …
            </td>
            <td class="cell4">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v14_121_antwort"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
            <td class="cell5">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v14_121_unterlage"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
        </tr>
        <tr class="table_row">
            <td class="cell1">
                <mat-checkbox [formControl]="fc_v14_122_handlungsbedarf" (change)="saveBSP()"></mat-checkbox>
            </td>
            <td class="cell2">14.122</td>
            <td class="cell3">
                Wenn vorhanden: Dung oder flüssige Abgänge werden in folgenden betriebseigenen Kläranlagen oder Anlagen
                zur technischen oder biologischen Aufarbeitung von Dung oder flüssigen Abgängen folgendem Verfahren
                unterzogen, durch das Tierseuchenerreger abgetötet werden: …
            </td>
            <td class="cell4">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v14_122_antwort"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
            <td class="cell5">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v14_122_unterlage"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
        </tr>
        <tr>
            <td colspan="5">
                <div>
                    <div class="pdf-upload-container">
                        <div class="one-row" style="width: 30%">
                            <input
                                #fileInput14
                                (change)="onFileChange($event, 'sektion14')"
                                [disabled]="isLoadingOrSaving() || isReadOnly()"
                                accept=".pdf"
                                hidden
                                type="file"
                            />
                            <button
                                (click)="handleFileButtonClick(fileInput14)"
                                [disabled]="isLoadingOrSaving() || isReadOnly()"
                                color="primary"
                                mat-icon-button
                            >
                                Hier können Sie weitere Dateien hinzufügen! <mat-icon>add</mat-icon>
                            </button>
                            <span class="spacer"></span>
                        </div>

                        <div class="chip-list-wrapper">
                            <mat-chip-list aria-label="PDF Auswahl">
                                <mat-chip
                                    *ngFor="let biofile of getSektionFiles('sektion14')"
                                    (click)="showFilePdf(biofile)"
                                    [removable]="!isLoadingOrSaving() && !isReadOnly()"
                                    (removed)="removeFile(biofile, 'sektion14')"
                                    selectable="false"
                                    matTooltip="{{ biofile?.dateiname || biofile?.file?.name }}"
                                >
                                    <mat-icon matChipAvatar>picture_as_pdf</mat-icon>
                                    {{ biofile?.dateiname || biofile?.file?.name }}
                                    <button
                                        matChipRemove
                                        *ngIf="!isLoadingOrSaving() && !isReadOnly()"
                                        (click)="$event.stopPropagation()"
                                    >
                                        <mat-icon>cancel</mat-icon>
                                    </button>
                                </mat-chip>
                            </mat-chip-list>
                        </div>
                    </div>
                </div>
            </td>
        </tr>
    </table>

    <!--    Seite 15-->
    <div class="one/row">
        <h2>HANDLUNGSEMPFEHLUNGEN ZU DEN IDENTIFIZIERTEN SCHWACHSTELLEN</h2>
    </div>
    <table class="margin-left biosicherheitsplan">
        <tr class="sektion_header">
            <th class="head1_15">zu Nr.</th>
            <th class="head2_15">Beschreibung der Schwachstelle</th>
            <th class="head3_15">Handlungsempfehlung</th>
            <th class="head4_15">Erledigt</th>
            <th class="head5_15">Ergänzende Unterlagen</th>
        </tr>

        <tr class="table_row">
            <td class="cell1">
                <mat-form-field style="width: 100%">
                    <input matInput [formControl]="fc_v123_zu_nr" (change)="saveBspTimeout()" />
                </mat-form-field>
            </td>
            <td class="cell3">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v123_schwachstelle"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
            <td class="cell4">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v123_handlungsempfehlung"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
            <td class="cell1">
                <mat-checkbox [formControl]="fc_v123_erledigt" (change)="saveBSP()"></mat-checkbox>
            </td>
            <td class="cell5">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v123_unterlage"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
        </tr>

        <tr class="table_row">
            <td class="cell1">
                <mat-form-field style="width: 100%">
                    <input matInput [formControl]="fc_v124_zu_nr" (change)="saveBspTimeout()" />
                </mat-form-field>
            </td>
            <td class="cell3">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v124_schwachstelle"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
            <td class="cell4">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v124_handlungsempfehlung"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
            <td class="cell1">
                <mat-checkbox [formControl]="fc_v124_erledigt" (change)="saveBSP()"></mat-checkbox>
            </td>
            <td class="cell5">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v124_unterlage"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
        </tr>

        <tr class="table_row">
            <td class="cell1">
                <mat-form-field style="width: 100%">
                    <input matInput [formControl]="fc_v125_zu_nr" (change)="saveBspTimeout()" />
                </mat-form-field>
            </td>
            <td class="cell3">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v125_schwachstelle"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
            <td class="cell4">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v125_handlungsempfehlung"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
            <td class="cell1">
                <mat-checkbox [formControl]="fc_v125_erledigt" (change)="saveBSP()"></mat-checkbox>
            </td>
            <td class="cell5">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="fc_v125_unterlage"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
        </tr>

        <!-- Dynamische Handlungsempfehlungen -->
        <tr class="table_row" *ngFor="let handlungsempfehlung of handlungsempfehlungen; let i = index">
            <td class="cell1">
                <mat-form-field style="width: 100%">
                    <input matInput [formControl]="handlungsempfehlung.zu_nr" (change)="saveBspTimeout()" />
                </mat-form-field>
            </td>
            <td class="cell3">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="handlungsempfehlung.schwachstelle"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
            <td class="cell4">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="handlungsempfehlung.handlungsempfehlung"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
            <td class="cell1">
                <mat-checkbox [formControl]="handlungsempfehlung.erledigt" (change)="saveBSP()"></mat-checkbox>
            </td>
            <td class="cell5">
                <mat-form-field style="width: 100%">
                    <textarea
                        [formControl]="handlungsempfehlung.unterlage"
                        cdkAutosizeMinRows="{{ rowspan }}"
                        cdkTextareaAutosize
                        class="textarea"
                        matInput
                        (change)="saveBspTimeout()"
                    ></textarea>
                </mat-form-field>
            </td>
            <td class="cell1">
                <button
                    mat-icon-button
                    color="warn"
                    (click)="removeHandlungsempfehlung(handlungsempfehlung)"
                    title="Handlungsempfehlung löschen"
                >
                    <mat-icon>delete</mat-icon>
                </button>
            </td>
        </tr>
    </table>

    <!-- Add Button für neue Handlungsempfehlungen -->
    <div class="one-row" style="margin-top: 10px">
        <button
            mat-raised-button
            color="primary"
            (click)="addHandlungsempfehlung()"
            [disabled]="handlungsempfehlungen.length >= 7"
            title="Neue Handlungsempfehlung hinzufügen"
        >
            <mat-icon>add</mat-icon>
            Handlungsempfehlung hinzufügen ({{ handlungsempfehlungen.length }}/7)
        </button>
        <span *ngIf="handlungsempfehlungen.length >= 7" style="margin-left: 10px; color: #f44336">
            Maximale Anzahl von 7 zusätzlichen Handlungsempfehlungen erreicht.
        </span>
    </div>

    <div style="display: flex; gap: 16px; align-items: flex-start; flex-wrap: wrap; margin-top: 16px; margin-bottom: 8px">
        <mat-form-field style="width: 220px; max-width: 100%">
            <mat-label>Beratungszeit Tierärztin/Tierarzt (Stunden)</mat-label>
            <input
                type="number"
                step="0.25"
                min="0"
                [formControl]="fc_beratungszeit_tierarzt"
                matInput
                (change)="saveBspTimeout()"
            />
        </mat-form-field>
        <mat-form-field *ngIf="hasBerater()" style="width: 220px; max-width: 100%">
            <mat-label>Beratungszeit Fachberaterin/Fachberater (Stunden)</mat-label>
            <input
                type="number"
                step="0.25"
                min="0"
                [formControl]="fc_beratungszeit_berater"
                matInput
                (change)="saveBspTimeout()"
            />
        </mat-form-field>
    </div>

    <div class="document-text-container">
        <h3 class="document-text">
            Hiermit beantrage ich die Beihilfe der Niedersächsischen Tierseuchenkasse für die Durchführung der
            Folgeberatung zur Biosicherheit, trete den Anspruch auf die Beihilfe an den vom beratenden Tierarzt/von der
            beratenden Tierärztin ab und erkläre mich damit einverstanden, dass die Beihilfe von diesem über das Portal
            der Nds. Tierseuchenkasse beantragt wird. Über die besonderen Regelungen der Datenschutzgrundverordnung
            (DSG-VO) hinsichtlich der Verarbeitung meiner personenbezogenen Daten und hinsichtlich meiner
            Datenschutzrechte wurde ich von der Niedersächsischen Tierseuchenkasse anlässlich der jährlichen Übersendung
            der Meldekarte informiert (Datenschutzhinweise unter www.ndstsk.de). Ich erkläre, dass mir gegenüber keine
            offene Rückforderungsanordnung der EU-Kommission aufgrund eines früheren Beschlusses der EU-Kommission zur
            Feststellung der Unzulässigkeit einer Beihilfe und ihrer Unvereinbarkeit mit dem Binnenmarkt besteht. Ich
            erkläre, dass der Betrieb kein Unternehmen in Schwierigkeiten ist und keine Änderungen im Ablauf der Prozesse
            vorgenommen wurden, die im Evaluationsbogen keine Erwähnung finden.
        </h3>
    </div>

    <!--    Bottom-->
    <div class="one-row">
        <div style="display: flex; gap: 16px; align-items: center; flex-wrap: wrap">
            <kiene-sign-button
                [kuid]="bsp.kuid"
                [tierarzt_id]="bsp.tierarzt_id"
                [kunde_id]="bsp.kunde_id"
                [disabled]="!bsp.bs_id || isLoadingOrSaving() || isReadOnly()"
                (kuid)="persistKuidToPlan($event)"
                (signDialogClosed)="onSignDialogClosed()"
            ></kiene-sign-button>
            <kiene-sign-button
                *ngIf="hasBerater()"
                [kuid]="bsp.berater_kuid"
                [beraterMode]="true"
                buttonText="Berater/in unterschreiben"
                [disabled]="!bsp.bs_id || isLoadingOrSaving() || isReadOnly()"
                (kuid)="persistBeraterKuidToPlan($event)"
                (signDialogClosed)="onBeraterSignDialogClosed()"
            ></kiene-sign-button>
        </div>
        <span class="spacer"></span>
        <ng-container *ngIf="bsp.status_id === 231 || bsp.status_id == null">
            <button
                *kienePermission="[11004]"
                (click)="abschliessen()"
                [disabled]="isLoadingOrSaving() || isReadOnly()"
                color="primary"
                mat-raised-button
            >
                <span>Abschließen</span>
            </button>
        </ng-container>
    </div>
</div>
